import React, { useState, useEffect, useRef } from 'react';
import CreatableSelect from 'react-select/creatable';
import Rapdf from "../../../../../assets/images/pdf.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPaperclip, faFileArrowDown, faPaperPlane, faTimes, faFilter, faFileLines, faEllipsisVertical, faPencilAlt, faCircle, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { Form, Button, Accordion, Row, Col, Modal, Table, Tabs, Tab, Dropdown } from 'react-bootstrap';
import { withRFSToken } from '../../../../../Services/axios';
import { ADDRESSBOOKDROPDOWN, GETDESTINATION, GETOWNERCODE, SHIPMENTSAVEINVOICECATEGORY } from '../../../../../Utils/conts';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Edit from "../../../../../assets/images/edit.png";

import AssetsIcon from '../../../../../assets/images/oparation.svg';
import Radown from "../../../../../assets/images/radown.png";
import AssetsIconw from '../../../../../assets/images/oparation_a.svg';
import Docmnt from '../../../../../assets/images/file.svg';
import Pack from '../../../../../assets/images/n_package.png';
import Uploadn from '../../../../../assets/images/upload-n.png';
import Uploadw from '../../../../../assets/images/upload-w.png';
import Trash from "../../../../../assets/images/trash.png";
import Shipupload from "../../../../../assets/images/ship_upload.png";
import { saveAs } from "file-saver";

import xls_file from "../../../../../assets/images/xls-file.png";
import view from "../../../../../assets/images/view.png";
import dwnld from "../../../../../assets/images/dwnld.png";
import cargohub_logo from "../../../../../assets/images/cargohub-logo.png";
import mail from "../../../../../assets/images/mail.png";
import dlt from '../../../../../assets/images/dlt.png';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import Invoice from './Invoice';
import Customer from '../../../../Settings/FSM/CustomerSettings';
import { jqxCookieCall } from '../../../../../Components/common/CommonFunctions';
import { useUserCheckQuery } from '../../../../../redux/services/Auth';

const AddImport = () => {

    const customStatus = [
        { value: "T1", label: "T1" },
        { value: "X", label: "X" },
        { value: "C", label: "C" },
        { value: "TD", label: "TD" },
        { value: "T2", label: "T2" },
    ]

    const initialFormData = {
        master_airwaybill: "",
        hawb: "",
        temperature_type: 'C',
        shipment_type: 'Inspection VWA',
        transport_type: 'Transfer',
        flight_details: [
            {
                id: "1",
                airline_name: "",
                flight_code: "",
                flight_number: "",
                flight_date: "",
                origin: "",
                destination: "",
                // etd: "",
                eta: "",
                ata: ""
            }
        ],
        bonded: "0",
        health_inspection: "0",
    };
    const formattedDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    const [formData, setFormData] = useState(initialFormData);
    const [disabled, setDisabled] = useState(true);
    const hasSHEdit = localStorage.getItem("SHEdit")
    useEffect(() => {
        const threeStepsComplete = checkStepsStatus(formData, [1, 2, 3]);
        if (threeStepsComplete) { setDisabled(false); }
        else { setDisabled(true); }
    }, [formData]);
    const [vwafilled, setVwaFilled] = useState(false)
    const [settingIds, setSettingIds] = useState({
        bonded: null,
        health_inspection: null
    });
    const [confirmModal, setConfirmModal] = useState(false)
    const [isContinue, setIsContinue] = useState(false);
    const confirmModalClose = () => {
        setConfirmModal(false);
    }
    const downloadInvoice = async (fileType) => {
        try {
            const localId = JSON.parse(localStorage.getItem('SHEdit'));
            if (!localId) {
                toast.error('Missing invoice id');
                return;
            }

            const payload = { id: Number(localId), type: fileType };
            const acceptType = fileType === 'excel'
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/pdf';

            const response = await withRFSToken.post('download-invoice', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': acceptType,
                },
                responseType: 'blob',
            });

            const contentType = response?.headers?.['content-type'] || acceptType;
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;

            let filename = `Invoice_${formData?.job_nr || formData?.job_no || 'import'}.${fileType === 'excel' ? 'xlsx' : 'pdf'}`;
            const disposition = response?.headers?.['content-disposition'];
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
                const extracted = decodeURIComponent(match?.[1] || match?.[2] || '').trim();
                if (extracted) filename = extracted;
            }
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Failed to download invoice:', error);
            toast.error('Failed to download invoice');
        }
    };

    const handleExportInvoiceExcel = () => {
        return downloadInvoice('excel');
    };

    const invoiceRef = useRef(null);
    const handleDownloadInvoicePDF = async () => {
        return downloadInvoice('pdf');
    };

    function getStepStatus(fields, nestedFieldsArray = [], includeNested = true) {
        const isFilled = v => v !== undefined && v !== null && v !== '';

        const topLevelValues = Object.values(fields);

        const nestedValues = includeNested
            ? nestedFieldsArray.flatMap(obj =>
                obj && typeof obj === 'object'
                    ? Object.entries(obj)
                        .filter(([key, value]) => key !== 'id' && typeof value !== 'object')
                        .map(([, value]) => value)
                    : []
            )
            : [];

        const allFields = [...topLevelValues, ...nestedValues];

        const filtered = allFields.filter(v => typeof v !== 'object' || v === null);

        if (filtered.length === 0 || filtered.every(v => !isFilled(v))) return 'circlegrey';
        if (filtered.every(isFilled)) return 'circlegreen';
        return 'circleorange';
    }

    function checkStepsStatus(formData, stepsToCheck = [1, 2, 3, 4, 5, 6, 7, 8]) {
        // Define all step configurations
        const stepConfigs = {
            1: {
                fields: {
                    shipment_type: formData.shipment_type,
                    master_airwaybill: formData.master_airwaybill,
                    hawb: formData.hawb,
                    type_of_goods: formData.type_of_goods,
                    e_pcs: formData.e_pcs,
                    e_weight: formData.e_weight,
                    customer_id: formData.customer_id,
                },
                flightDetails: [
                    {
                        id: formData.flight_details[0].id,
                        airline_name: formData.flight_details[0].airline_name,
                        flight_code: formData.flight_details[0].flight_code,
                        flight_number: formData.flight_details[0].flight_number,
                        // flight_date: formData.flight_details[0].flight_date,
                        // origin: formData.flight_details[0].origin,
                        destination: formData.flight_details[0].destination,
                        ata: formData.flight_details[0].ata
                    }
                ],
                hasFlightDetails: true
            },
            2: {
                fields: {
                    transport_type: formData.transport_type,
                    handler_name: formData.t_handler_org_id,
                    delivery_date: formData.delivery_date,
                    // delivery_time: formData.delivery_time,
                }
            },
            3: {
                fields: {
                    no_of_fytos: formData.no_of_fytos,
                    inspection_date: formData.inspection_date,
                    inspection_start_time: formData.inspection_start_time,
                    inspection_end_time: formData.inspection_end_time,
                    //inspection_remarks: formData.inspection_remarks,
                }
            },
            4: {
                fields: {
                    shipment_arrived: formData.shipment_arrived,
                    shipment_arrived_info_shipment_class: formData.shipment_class,
                }
            },
            5: {
                fields: {
                    warehouse_in: formData.warehouse_in,
                    warehouse_in_doc_type: formData.warehouse_in_doc_type,
                    warehouse_in_doc_no: formData.warehouse_in_doc_no,
                    location: formData.location,
                    temparature: formData.temparature,
                    split_shipment: formData.split_shipment,
                }
            },
            6: {
                fields: {
                    inspection_status: formData.inspection_status,
                    location: formData.location,
                    inspection_center: formData.inspection_center,
                }
            },
            7: {
                fields: {
                    release_id_type: formData.release_id_type,
                    release_id_number: formData.release_id_number,
                    release_to: formData.release_to,
                    release_carrier_code: formData.release_carrier_code,
                    release_information_handler_name: formData.r_handler_org_id,
                    location: formData.location,
                    release_remarks: formData.release_remarks,
                }
            },
            8: {
                fields: {
                    warehouse_out: formData.warehouse_out,
                    warehouse_out_doc_type: formData.warehouse_out_doc_type,
                    warehouse_out_doc_no: formData.warehouse_out_doc_no,
                }
            }
        };
        const stepStatuses = stepsToCheck.map(stepNumber => {
            const config = stepConfigs[stepNumber];
            if (!config) return 'invalid';

            return getStepStatus(
                config.fields,
                config.flightDetails,
                config.hasFlightDetails
            );
        });

        // Check if all specified steps are green (completed)
        return stepStatuses.every(status => status === 'circlegreen');
    }



    const step1 = {
        shipment_type: formData.shipment_type,
        master_airwaybill: formData.master_airwaybill,
        hawb: formData.hawb,
        type_of_goods: formData.type_of_goods,
        e_pcs: formData.e_pcs,
        e_weight: formData.e_weight,
        // country_code: formData.country_code,
        customer_id: formData.customer_id,
        flight_details: formData.flight_details?.map(fd => ({
            id: fd.id,
            airline_name: fd.airline_name,
            flight_code: fd.flight_code,
            flight_number: fd.flight_number,
            // flight_date: fd.flight_date,
            // origin: fd.origin,
            destination: fd.destination,
            ata: fd.ata
        })),
        shipment_arrived_info_shipment_class: formData.shipment_class,
    };
    const step2 = {
        transport_type: formData.transport_type,
        handler_name: formData.t_handler_org_id,
        delivery_date: formData.delivery_date,
    };

    const getSectionStatus = (sectionFields) => {
        // const values = sectionFields ? Object.values(sectionFields) : '';
        // const filledCount = values ? values.filter(val => val !== '' && val !== null && val !== undefined).length : 0;
        let filled = 0;
        let total = 0;
        const excludedKeys = ['id'];

        const count = (data) => {
            if (Array.isArray(data)) {
                data.forEach(item => count(item));
            } else if (typeof data === 'object' && data !== null) {
                // Object.values(data).forEach(value => count(value));
                Object.entries(data).forEach(([key, value]) => {
                    if (!excludedKeys.includes(key)) {
                        count(value);
                    }
                });
            } else {
                total += 1;
                if (data !== '' && data !== null && data !== undefined) {
                    filled += 1;
                }
            }
        };

        count(sectionFields);

        if (filled === 0) return 'circlegrey';
        if (filled === total && total > 0) return 'circlegreen';
        return 'circleorange';
    };

    const CustomerOptions = [
        // { label: '--', value: '' },
        { label: 'Airline', value: 'A' },
        { label: 'Forwarder', value: 'F' },
        { label: 'Handler', value: 'H' },
        { label: 'Trucker', value: 'T' }
    ];

    const TransportOptions = [
        { label: 'Transfer', value: 'Transfer' },
    ]

    const TemperatureOptions = [
        { label: 'Celsius', value: 'C' },
        { label: 'Fahrenheit', value: 'F' },
    ];
    const IdTypeOption = [
        { label: 'ACN card', value: 'ACN card' },
        { label: 'Driver license', value: 'Driver license' },
        { label: 'Passport', value: 'Passport' },
        { label: 'Other', value: 'Other' },
    ]

    const shipmentTypeOption = [
        { label: '--', value: '-' },
        { label: 'Inspection VWA', value: 'VWA' },
        { label: 'Inspection PD', value: 'PD' },
    ];
    const incotermOption = [
        // { label: '--', value: '' },
        { label: 'EXW - Ex Works', value: 'EXW' },
        { label: 'FCA - Free Carrier', value: 'FCA' },
        { label: 'FAS - Free Alongside Ship', value: 'FAS' },
        { label: 'FOB - Free On Board', value: 'FOB' },
        { label: 'CPT - Carriage Paid To', value: 'CPT' },
        { label: 'CIP - Carriage and Insurance Paid', value: 'CIP' },
        { label: 'CFR - Cost and Freight', value: 'CFR' },
        { label: 'CIF - Cost Insurance and Freight', value: 'CIF' },
        { label: 'DAP - Delivered At Place', value: 'DAP' },
        { label: 'DPU - Delivered At Place Unloaded', value: 'DPU' },
        { label: 'DDP - Delivered Duty Paid', value: 'DDP' }
    ];
    const acceptanceWarehouseInhandlerOptions = [
        // { label: '--', value: '' },
        { label: 'Transfer', value: 'Transfer' },
        { label: 'NCTS', value: 'NCTS' },
        { label: 'IM4', value: 'IM4' },

    ];
    const TransportShipmentType = [
        // { label: '--', value: '' },
        { label: 'Inspection VWA', value: 'Inspection VWA' },
        { label: 'Inspection PD', value: 'Inspection PD' },
        { label: 'Storage', value: 'Storage' },
        { label: 'Destruction', value: 'Destruction' },
    ];
    const VwsShipmentClass = [
        // { label: '--', value: '' },
        { label: 'Human consumption  HC)', value: 'HC' },
        { label: 'Non Human Consumption (NHC)', value: 'NHC' },
        { label: 'Live animals (AVI)', value: 'AVI' },
    ];
    const isMounted = useRef(false);
    // 1. Refactor formData to unified structure



    const CentreOptions = [
        { label: 'Dnata', value: 'Dnata' }
    ];

    const [disablePcs, setDisablePcs] = useState();

    const [getDestination, setGetDestination] = useState([]);
    const [getHandler, setGetHandler] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [shipperOptions, setShipperOptions] = useState([]);
    const [consigneeOptions, setConsigneeOptions] = useState([]);
    const userId = localStorage.getItem('Email')

    const [addLocationModal, setAddLocationModal] = useState(false);
    const [contactModal, setContactModal] = useState(false);
    const [locationModal, setLocationModal] = useState(false);
    const [locationData, setLocationData] = useState({});

    const [getPackaging, setGetPackaging] = useState([]);
    const [getInvoice, setGetInvoice] = useState([]);

    const [detailsModal, setDetailsModal] = useState(false);
    const [acceptanceModal, setAcceptanceModal] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);

    // Release modal state
    const [releaseModal, setReleaseModal] = useState(false);
    const [deliverModal, setDeliverModal] = useState(false);
    const [releaseData, setReleaseData] = useState({ hawb_details: [] });
    const [deliverData, setDeliverData] = useState({ hawb_details: [] });
    const [companyOption, setCompanyOption] = useState([]);
    const [userDetails, setUserDetails] = useState();

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const loadCompany = async () => {
        try {
            const res = await withRFSToken
                .get('address-book/dropdown', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData
                        ? innerData.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))
                        : [];
                    setCompanyOption(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Acceptance form state
    const [acceptanceFormData, setAcceptanceFormData] = useState({
        hawb: '',
        e_pcs: '',
        e_weight: '',
        piecesConfirm: 'YES',
        a_pcs: '',
        a_weight: '',
        location: '',
        temparature: '',
        temperature_type: '',
        warehouse_in: '',
        warehouse_in_doc_type: '',
        warehouse_in_doc_no: ''
    });

    // Handler for acceptance form changes
    const handleAcceptanceFormChange = (field, value) => {
        setAcceptanceFormData(prev => {
            let updatedData = { ...prev, [field]: value };

            if (field === 'a_pcs') {
                const expectedPcs = parseFloat(updatedData.e_pcs) || 0;
                const expectedWeight = parseFloat(updatedData.e_weight) || 0;
                const acceptedPcs = parseFloat(value) || 0;

                // Validation: Accepted pieces can't be greater than expected
                // if (acceptedPcs > expectedPcs) {
                //     toast.error("Accepted pieces can't be greater than Expected Pieces", {
                //     toastId: "pcs-limit-error"
                //     });
                //     return prev; 
                // }

                if (expectedPcs > 0) {
                    const ratio = acceptedPcs / expectedPcs;
                    const calculatedWeight = (expectedWeight * ratio).toFixed(2);
                    updatedData.a_weight = calculatedWeight;
                }
            }

            // if (field === 'a_weight') {
            // if (parseFloat(updatedData.a_weight) > parseFloat(updatedData.e_weight)) {
            //     toast.error("Accepted weight can't be greater than Expected Weight", {
            //     toastId: "weight-limit-error"
            //     });
            //     return prev; 
            // }
            // }

            return updatedData;
        });
    };



    // Initialize acceptance form when modal opens
    const initializeAcceptanceForm = () => {
        setAcceptanceFormData({
            hawb: formData.hawb || '',
            e_pcs: formData.expected_pcs || '',
            e_weight: formData.e_weight || '',
            piecesConfirm: 'YES',
            a_pcs: formData.expected_pcs || '',
            a_weight: formData.e_weight || '',
            location: formData.location || '',
            temparature: formData.temparature || '',
            temperature_type: formData.temperature_type || '',
            warehouse_in: formData.warehouse_in ||
                new Date()
                    .toLocaleString("sv-SE", { hour12: false })
                    .replace(" ", "T")
                    .slice(0, 16),
            warehouse_in_doc_type: formData.warehouse_in_doc_type || 'Transfer',
            warehouse_in_doc_no: formData.warehouse_in_doc_no || ''
        });
    };

    const handleCheckSubmit = () => {
        const invalidItem = parseFloat(acceptanceFormData.a_pcs) > parseFloat(acceptanceFormData.e_pcs);
        if (invalidItem)
            setConfirmModal(true);
        else
            handleAcceptanceSubmit();
    }

    // Handle acceptance submission
    const handleAcceptanceSubmit = async () => {
        try {
            const payload = {
                mawb_id: formData.import_shipment_information_id,
                hawb_details: [{
                    id: formData.import_shipment_information_id, // Using shipment ID as HAWB ID
                    accepted_pcs: acceptanceFormData.a_pcs,
                    accepted_weight: acceptanceFormData.a_weight,
                    location: acceptanceFormData.location,
                    temparature: acceptanceFormData.temparature,
                    temperature_type: acceptanceFormData.temperature_type,
                    warehouse_in: acceptanceFormData.warehouse_in,
                    warehouse_in_doc_type: acceptanceFormData.warehouse_in_doc_type,
                    warehouse_in_doc_no: acceptanceFormData.warehouse_in_doc_no,
                }]
            };
            // const invalidItem = parseFloat(acceptanceFormData.a_pcs) > parseFloat(acceptanceFormData.e_pcs);
            // if (!isContinue && invalidItem) {
            //     setConfirmModal(true);
            //     return;
            // }
            const response = await withRFSToken.post('shipment/move-to-in-stock', payload);

            if (response.data.response_code == 200) {
                setAcceptanceModal(false);
                setConfirmModal(false);
                // Optionally refresh the page or show success message
                //window.location.reload();
                toast.success(response.data.response_msg)
                const localData = JSON.parse(localStorage.getItem('SHEdit'));
                if (localData) { fetchUser(localData); } else { fetchUser(); }
            } else {
                toast.error(response.data.response_msg)
            }
        } catch (error) {
            console.error('Error submitting acceptance:', error);
        }
    };

    // Initialize Release modal data (single HAWB group from formData)
    const initializeReleaseForm = () => {
        setReleaseData({
            hawb_details: [
                {
                    hawb: formData.hawb || '',
                    is_deliver: '0',
                    to_be_picked_pcs:
                        (Number(formData?.cargo_acceptance_det_details?.actual_hawb_pieces) || 0) -
                        (Number(formData?.released_pcs) || 0),
                    picked_pcs: '',
                    delivered_pcs: '',
                    name: '',
                    warehouse_out: new Date()
                        .toLocaleString("sv-SE", { hour12: false })
                        .replace(" ", "T")
                        .slice(0, 16), // e.g. "2025-08-27T14:35"
                    warehouse_out_doc_type: 'Transfer',
                    warehouse_out_doc_no: '',
                    // actual_pcs_snapshot, picklist, location will be provided later
                }
            ]
        });
    };
    const initializeDeliverForm = () => {
        setDeliverData({
            hawb_details: [
                {
                    hawb: formData.hawb || '',
                    is_deliver: '1',
                    to_be_picked_pcs: '',
                    picked_pcs: '',
                    delivered_pcs: '',
                    name: '',
                    warehouse_out: new Date()
                        .toLocaleString("sv-SE", { hour12: false })
                        .replace(" ", "T")
                        .slice(0, 16), // e.g. "2025-08-27T14:35"
                    warehouse_out_doc_type: 'Transfer',
                    warehouse_out_doc_no: '',
                }
            ]
        });
    };


    const handleReleaseGroupChange = (idx, field, value) => {
        const maxAllowed = formData?.cargo_acceptance_det_details?.actual_hawb_pieces || 0;

        // fields that must not exceed max allowed
        const restrictedFields = ["to_be_picked_pcs", "picked_pcs", "delivered_pcs"];

        // fields that should be numbers
        const numericFields = ["to_be_picked_pcs", "picked_pcs", "delivered_pcs"];

        let newValue = value;
        if (numericFields.includes(field)) {
            newValue = Number(value);
            if (newValue > maxAllowed) {
                toast.error(`${field.replace(/_/g, " ")} cannot be greater than ${maxAllowed}`);
                return; // prevent update
            }
        }

        setReleaseData(prev => {
            const details = [...(prev.hawb_details || [])];
            details[idx] = { ...(details[idx] || {}), [field]: newValue };
            return { ...prev, hawb_details: details };
        });
    };

    const handleDeliverGroupChange = (idx, field, value) => {
        const maxAllowed = formData?.cargo_acceptance_det_details?.actual_hawb_pieces || 0;

        // fields that must not exceed max allowed
        const restrictedFields = ["to_be_picked_pcs", "picked_pcs", "delivered_pcs"];

        // fields that should be numbers
        const numericFields = ["to_be_picked_pcs", "picked_pcs", "delivered_pcs"];

        let newValue = value;
        if (numericFields.includes(field)) {
            newValue = Number(value);
            if (newValue > maxAllowed) {
                toast.error(`${field.replace(/_/g, " ")} cannot be greater than ${maxAllowed}`);
                return; // prevent update
            }
        }

        setDeliverData(prev => {
            const details = [...(prev.hawb_details || [])];
            details[idx] = { ...(details[idx] || {}), [field]: newValue };
            return { ...prev, hawb_details: details };
        });
    };

    const handleReleaseSubmit = async () => {
        try {
            const payload = {
                company_name: releaseData?.company_name,
                trucking_Id: releaseData?.trucking_Id,
                mawb_id: formData.cargo_acceptance_det_details?.mawb_id,
                hawb_details: releaseData.hawb_details.map(group => ({
                    id: formData.cargo_acceptance_det_details?.hawb_id,
                    release_to: group.release_to,
                    release_id_number: group.release_id_number,
                    release_id_type: group.release_id_type,
                    import_shipment_record_id: formData.import_shipment_information_id,
                    hawb: group.hawb,
                    pick_status: "Open",
                    picked_pc: group.picked_pcs,
                    to_be_picked_pcs: group.to_be_picked_pcs,
                    picklist: "",
                    is_deliver: group.is_deliver,
                    ...(Number(group.is_deliver) === 1 && {
                        warehouse_out_doc_type: group.warehouse_out_doc_type,
                        warehouse_out_doc_no: group.warehouse_out_doc_no,
                        warehouse_out: group.warehouse_out,
                        delivered_pcs: group.delivered_pcs,
                        picked_pcs: group.picked_pcs,
                        name: group.name
                    })
                })),
                //cargoid: [formData.cargo_acceptance_det_details?.mawb_id],
                tabType: "MAWB"
            };

            const response = await withRFSToken.post('shipment/move-to-release', payload);

            if (response.data.response_code == 200) {
                setReleaseModal(false);
                toast.success(response.data.response_msg)
                // Optionally refresh the page or show success message
                const localData = JSON.parse(localStorage.getItem('SHEdit'));
                if (localData) { fetchUser(localData); } else { fetchUser(); }
            } else {
                toast.error(response.data.response_msg)
            }
        } catch (error) {
            console.error('Error submitting release:', error);
        }
    };
    const handleDeliverSubmit = async () => {
        try {
            const payload = {
                company_name: deliverData?.company_name,
                trucking_Id: deliverData?.trucking_Id,
                mawb_id: formData.cargo_acceptance_det_details?.mawb_id,
                hawb_details: deliverData.hawb_details.map(group => ({
                    id: formData.cargo_acceptance_det_details?.hawb_id,
                    import_shipment_record_id: formData.import_shipment_information_id,
                    hawb: group.hawb,
                    //pick_status: "Open", // static for now    
                    picked_pc: group.picked_pcs,
                    //picklist: "", // will be provided later
                    is_deliver: group.is_deliver,
                    warehouse_out_doc_type: group.warehouse_out_doc_type,
                    warehouse_out_doc_no: group.warehouse_out_doc_no,
                    warehouse_out: group.warehouse_out,
                    delivered_pcs: group.delivered_pcs,
                    picked_pcs: group.picked_pcs,
                    name: group.name
                })),
                //cargoid: [formData.cargo_acceptance_det_details?.mawb_id],
                tabType: "MAWB"
            };

            const response = await withRFSToken.post('shipment/move-to-delivered', payload);

            if (response.data.response_code == 200) {
                setDeliverModal(false);
                // Optionally refresh the page or show success message
                toast.success(response.data.response_msg)
                const localData = JSON.parse(localStorage.getItem('SHEdit'));
                if (localData) { fetchUser(localData); } else { fetchUser(); }
            } else {
                toast.error(response.data.response_msg)
            }
        } catch (error) {
            console.error('Error submitting release:', error);
        }
    };

    // Type of goods options
    const typeOfGoodsOptions = [
        { value: "Inspection VWA", label: "Inspection VWA" },
        { value: "Inspection PD", label: "Inspection PD" },
        { value: "Storage", label: "Storage" },
        { value: "Destruction", label: "Destruction" }
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [isEditable, setIsEditable] = useState(() => {
        return !localStorage.getItem("SHEdit");
    });
    const [isLoadingl, setIsLoadingl] = useState(true);

    const lgridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [lgridData, setLgridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [countryCode, setCountryCode] = useState([]);

    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                    ;
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCountryCode = async () => {
        try {

            const res = await withRFSToken.post("uld-forms/get-country-code", {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const countryCodeData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.label
                    })) : [];
                    setCountryCode(countryCodeData);
                    ;
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchInvoice = async () => {
        try {

            const res = await withRFSToken.get('shipment/get-invoice-categories', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const filteredData = innerData.filter(item => item.status == 1);
                    setGetInvoice(filteredData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchLocation = async () => {
        try {
            setIsLoadingLocation(true);
            const res = await withRFSToken.get("forwarder-location/list?filtervalue0=Inactive");
            const innerData = res.data?.Rows;
            const transformedData = innerData ? innerData.map(item => ({
                value: item.location,
                label: item.location,
            })) : [];
            setLocationOptions(transformedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoadingLocation(false);
        }
    };
    const [movementLog, setMovementLog] = useState();
    const fetchMovementLog = async (localData, e) => {
        try {

            const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: [`${localData}`], type: `${e}` })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setMovementLog(innerData);
                    setDetailsModal(true);
                    // const filteredData = innerData.filter(item => item.status == 1);
                    // setGetInvoice(filteredData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [deliveryTab, setDeliveryTab] = useState('in_stock');
    const [deliveryLogs, setDeliveryLogs] = useState([]);
    const [isLoadingDelivery, setIsLoadingDelivery] = useState(false);
    // const fetchDeliveryLogs = async (type) => {
    //     const localData = localStorage.getItem("SHEdit");
    //     if (!localData) {
    //         setDeliveryLogs([]);
    //         return;
    //     }
    //     try {
    //         setIsLoadingDelivery(true);
    //         const shipmentId = parseInt(localData, 10);
    //         const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: [shipmentId], type: type })
    //             .then(function (res) {
    //                 const innerData = res.data.response_data;
    //                 setDeliveryLogs(innerData || []);
    //             });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         setDeliveryLogs([]);
    //     } finally {
    //         setIsLoadingDelivery(false);
    //     }
    // };
    // useEffect(() => {
    //     fetchDeliveryLogs(deliveryTab);
    // }, [deliveryTab]);
    const fetchHandler = async () => {
        try {

            const res = await withRFSToken.get("shipment/get-handler-list")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.label,
                    })) : [];
                    setGetHandler(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPackaging = async () => {
        try {

            const res = await withRFSToken.post('shipment/type-of-packaging', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.description,
                    })) : [];
                    setGetPackaging(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [hawbDetails, setHawbDetails] = useState();
    const loadHawbDetails = async () => {
        const localData = localStorage.getItem("SHEdit")
        try {

            const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: [localData], type: 'all' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transData = { ...localData, mvtLog: innerData }
                    setHawbDetails(transData);
                    //setSubMawb(true);
                    //   setTimeout(() => {
                    //     window.$(gridRefs[activeTab].current).jqxGrid("refresh");
                    //   }, 30);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        airline_name: item.airline_name
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchUser = async (edidId) => {
        try {
            setDisLoading(true)
            const res = await withRFSToken.get(`uld-setting/get-user-list`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.user_id,
                        label: item.first_name + ' ' + item.last_name,
                        email: item.email_id,
                    })) : [];
                    setUserList(transformedData);
                    // if (innerData.length > 0) {
                    if (!edidId) {
                        const isDefault = innerData?.find(dflt => dflt.email_id == userDetails?.email_id)
                        setFormData(prevFormData => ({ ...prevFormData, assigned_to: isDefault?.user_id }))
                        setDisLoading(false)
                    } else {
                        const res = withRFSToken.post(`shipment/import-shipment-record-details/${edidId}`, {})
                            .then(function (res) {
                                const innerDatas = res.data.response_data;
                                setDisablePcs(innerDatas?.is_partial)
                                // setSelectedRowData(innerData);
                                // const isDefault = innerData?.find(dflt => dflt.email_id == userId)
                                const transformData = {
                                    ...innerDatas,
                                    // assigned_to: innerDatas.assigned_to == null ? isDefault?.user_id : innerData.assigned_to,
                                    // dimensions: innerDatas.dimensions?.length > 0 ? innerDatas.dimensions : [{ id: '1', pieces: '', length: '', width: '', height: '', }],
                                    flight_details: innerDatas?.flight_details?.length > 0 ? innerDatas.flight_details : [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', eta: '', ata: '' }] || [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', eta: '', ata: '' }],
                                    setting_status: innerDatas?.setting_status?.id,
                                    setting_department: innerDatas?.setting_department?.id,
                                }
                                setFormData(prev => ({
                                    ...transformData,
                                    bonded: prev.bonded,
                                    health_inspection: prev.health_inspection,
                                }));
                                // const transData = innerDatas.invoice?.items?.map(i => {
                                //     const { category, ...rest } = i
                                //     return rest
                                // })
                                const transformedItems = innerDatas?.invoice?.items?.map((item) => ({
                                    no: item?.category.no || '',
                                    id: item?.category.id || '',
                                    qty: item?.qty || '',
                                    amount: item?.amount || '',
                                    category: item?.category.id || '',
                                    ttl: item?.qty * item?.amount || '',
                                    vat: item?.vat || 0,
                                    vatAmount: (item?.qty * item?.amount * item?.vat / 100) || 0
                                }));
                                setInvoiceDetails(transformedItems || [])
                                setDisLoading(false)
                            });
                        if (selectedTab == 'invoice') {

                        }
                    }

                    // }

                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStatus = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=import&type=S`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setStatusList(transformedData);
                    if (innerData.length > 0) {
                        const isDefault = innerData?.find(dflt => dflt.is_default === 1)
                        setFormData(prevFormData => ({ ...prevFormData, setting_status: isDefault.id }))
                    }

                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchShipperConsignee = async (tab) => {
        try {
            const res = await withRFSToken.post("address-book/customer-name-type", { tab: tab });
            const innerData = res.data.Rows;
            const transformedData = innerData ? innerData.map(item => ({
                value: item.id,
                label: item.name,
            })) : [];
            if (tab == "Shipper") {
                setShipperOptions(transformedData);
            } else if (tab == "Consignee") {
                setConsigneeOptions(transformedData);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDepartment = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=import&type=D`, {})
                .then(function (res) {

                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setDepartmentList(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const loadDetails = async (uldNumber) => {
        // const uldNumber = JSON.parse(localStorage.getItem('SHEdit'));
        try {
            const res = await withRFSToken.post(`shipment/import-shipment-record-details/${uldNumber}`, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setSelectedRowData(innerData);
                    const isDefault = userList?.find(dflt => dflt.email == userDetails?.email_id)
                    const transformData = {
                        ...innerData,
                        // setting_user: innerData.assigned_to == null ? isDefault?.value : innerData.assigned_to,
                        setting_status: innerData.setting_status?.id,
                        setting_department: innerData.setting_department?.id,
                    }

                    // Exclude bonded and health_inspection from formData update
                    // const { bonded, health_inspection, ...restTransformData } = transformData;
                    setFormData(transformData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchGeneralSettings = async () => {
        try {
            const res = await withRFSToken.get('shipment/get-general-settings', {});
            if (res.data.response_code === 200) {
                const settings = res.data.response_data;
                const bondedSetting = settings.find(s => s.name === 'Bonded Doc Number');
                const healthSetting = settings.find(s => s.name === 'Health Inspection');
                setFormData(prev => ({
                    ...prev,
                    bonded: bondedSetting ? String(bondedSetting.status) : '0',
                    health_inspection: healthSetting ? String(healthSetting.status) : '0',
                }));

                setSettingIds({
                    bonded: bondedSetting?.id || null,
                    health_inspection: healthSetting?.id || null
                });


                // Set default tab based on health inspection status
                // const shId = JSON.parse(localStorage.getItem('SHEdit'));
                // Set default tab based on health inspection status
                // if (!shId) {
                if (healthSetting && healthSetting.status === 1) {
                    setSelectedTab('vwa');
                } else {
                    setSelectedTab('details');
                }
                // }
            }
        } catch (error) {
            console.error('Error fetching general settings:', error);
        }
    };
    const fetchPref = async () => {
        try {
            const res = await withRFSToken.get('forwarder-user-setting/get-setting', {});
            if (res.data.response_code === 200) {
                const { inspection_center } = res.data.response_data.settings || {};
                setFormData(prev => ({
                    ...prev,
                    inspection_center: inspection_center
                }));
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleGeneralSettingChange = async (settingType, value) => {
        const settingId = settingIds[settingType];
        if (!settingId) return;

        try {
            const res = await withRFSToken.post('shipment/save-org-general-setting', {
                general_setting_id: settingId,
                status: Number(value),
            });
            if (res.data.response_code === 200) {
                setFormData(prev => ({
                    ...prev,
                    [settingType === 'bonded' ? 'bonded' : 'health_inspection']: String(value),
                }));
                toast.success('Status updated successfully');
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error updating status:', error);
            toast.error('Failed to update status');
        }
    };

    const editRecordId = JSON.parse(localStorage.getItem('SHEdit'));
    useEffect(() => {
        if (isMounted.current) return;
        const localData = JSON.parse(localStorage.getItem('SHEdit'));
        // if (localData) {
        //     setFormData(localData);
        // }
        // if (localData) { loadDetails(localData); }
        if (localData) { fetchUser(localData); } else { fetchUser(); }

        fetchGeneralSettings();
        fetchPref();
        // fetchMovementLog(localData);
        fetchStatus();
        fetchShipperConsignee("Shipper");
        loadCompany();
        fetchShipperConsignee("Consignee");
        fetchDepartment();
        fetchDestination();
        fetchCountryCode();
        fetchOwnerCode();
        fetchHandler();
        // fetchCustomer();
        fetchPackaging();
        fetchInvoice();
        loadHawbDetails();
        isMounted.current = true;
    }, []);

    const shId = JSON.parse(localStorage.getItem('SHEdit'));

    const [activeStep, setActiveStep] = useState(0);
    const [activeTab, setActiveTab] = useState('All');
    const [activeMsgTab, seActiveMsgTab] = useState("In")
    const [selectedButton, setSelectedButton] = useState('general');
    const [sendData, setSendData] = useState({});
    const [checkList, setCheckList] = useState({});

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [files, setFiles] = useState([]);
    const [rfiles, setRfiles] = useState([]);
    const fileInputRef = useRef(null);
    const fileInputRefs = useRef({});
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [uploadTarget, setUploadTarget] = useState('');
    const [updateInvoices, setUpdateInvoices] = useState([]);

    let checkUlds = [];
    let filterForCheck = false;


    useEffect(() => {
        if (lgridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()

            const source = {
                datatype: 'json',

                // root: 'response_data',
                cache: false,
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'location', type: 'string' },
                    { name: 'activity_status', type: 'string' },
                    { name: 'created_by', type: 'string' },
                    { name: 'station', type: 'string' }
                ],
                url: `${process.env.REACT_APP_RFS_URL}forwarder-location/list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(lgridRef.current).jqxGrid('clearselection');
                    window.$(lgridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(lgridRef.current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(lgridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    // source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(lgridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions', cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + Edit + '" class="row_edit" /></div>';
                    },
                    width: '6%', filterable: false,
                },
                {
                    text: 'Sl. No', datafield: 'sl_no', width: '15%',
                    cellsrenderer: (rowIndex) => {
                        const serialNo = rowIndex + 1;
                        const formattedNo = serialNo < 10 ? `0${serialNo}` : `${serialNo}`;
                        return `<div class="grid_actions">${formattedNo}</div>`;
                    }
                },
                {
                    text: 'Status', datafield: 'activity_status', width: '15%',
                    cellsrenderer: (rowIndex, dataField, cellValue) => {
                        const isActive = cellValue === '1' || cellValue === 1;
                        const status = isActive ? 'Active' : 'Inactive';
                        const colorClass = isActive ? 'text-success' : 'text-danger';
                        return `<div class="jqx-grid-cell-left-align ${colorClass}" style="margin-top: 12px; margin-left:5px">${status}</div>`;
                    }
                },
                { text: 'Location', datafield: 'location', width: '15%' },
                { text: 'Station', datafield: 'station', width: '15%' },
                { text: 'Created By', datafield: 'created_by', width: '15%' },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 600,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(lgridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(lgridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(lgridRef.current).jqxGrid(gridOptions);
            window.$(lgridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(lgridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(lgridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(lgridRef.current).jqxGrid('getrowdata', rowIndex);
                const id = rowData.id
                setAddLocationModal(true);
                setLocationData({ id: id, station: rowData?.station, location: rowData?.location })
            });
            window.$(lgridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(lgridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(lgridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            // window.$(lgridRef.current).off('cellclick');
            // window.$(lgridRef.current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (![4, 10].includes(event.args.columnindex)) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(lgridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         // loadDetails(args.uld_number);
            //         setSelectedRowData(args)
            //         setTimeout(() => {
            //             window.$(lgridRef.current).jqxGrid('refresh');
            //         }, 30);
            //     }
            // });
            // }
        }
    }, [lgridData]);

    // useEffect(() => {
    //     setSelectedButton(initialTab);
    // }, [initialTab]);
    // console.log('555', selectedButton);
    const handleButtonClick = async (button) => {
        if (button == 'remarks') { setActiveStep(2) }
        else if (button == 'attachment') {
            setActiveStep(1);
            if (!formData.id && formData.master_airwaybill) {
                try {
                    const res = await withRFSToken.post('shipment/save-import-shipment-record', formData);
                    // console.log('API Response:', res.data);
                    if (res.data.response_code === 200) {
                        localStorage.setItem('SHEdit', JSON.stringify(res.data.response_data.id));
                        setFormData(res.data.response_data);
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            }
        }
        else { setActiveStep(0) }
        setSelectedButton(button);
    };

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    const handleMsgTabChange = (tab) => {
        seActiveMsgTab(tab)
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken.post("get-file-blob", { file_path: imageUrl, })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };
    const toggleAccordionItem = async (index, msg, pos) => {

        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
    };

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setSendData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }
    // IMAGE UPLOAD START
    const imageModalUpload = () => {
        setShowModalUpload(true);
    }
    const closeModalUpload = () => {
        setShowModalUpload(false);
        setFiles([])
        setBase64Files([])
    }
    const handleDrop = (e) => {
        e.preventDefault();
        console.log('E', e);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const selectedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    let newBase64Files;
                    if (uploadTarget) {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [uploadTarget] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    setSendData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
        // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        // getBase64(droppedFiles[0]);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, pos) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        if (pos == 'R') {
            setRfiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            if (pos == 'R') {

                setSendData((prevFormData) => {
                    // const newFiles = [...prevFormData.files];
                    const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
                    newFiles.splice(index, 1);
                    return { ...prevFormData, files: newFiles };
                });
            }
            // Update local storage


            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e, nam) => {
        e.preventDefault();
        console.log('fileInputRef.current', fileInputRef);
        if (nam) {
            if (fileInputRefs.current[nam]) {
                fileInputRefs.current[nam].click();
            }
        } else { fileInputRef.current.click(); }
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e, pos, chk) => {
        if (formData.id) {
            const selectedFiles = Array.from(e.target.files);
            const filesWithBase64 = [];
            let filesProcessed = 0;

            // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
            const existingBase64Files = formData?.base64Files || [];

            selectedFiles.forEach((file) => {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    if (file.size > 26214400) {
                        toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                        return;
                    }
                    filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
                    filesProcessed += 1;
                    if (filesProcessed === selectedFiles.length) {
                        // if (pos === 'C') { // pos === 'A' || 
                        //     // const newFiles = filesWithBase64.map((obj) => obj.file);
                        //     // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                        //     const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                        //     const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                        //     // setFiles(newFiles);


                        //     const payload = {
                        //         shipmen_id: formData.id,
                        //         shipmen_type: "export",
                        //         attachments: mergedBase64Files
                        //     }
                        //     // console.log('payload', payload);
                        //     try {
                        //         const res = await withRFSToken.post('shipment/upload-doc', payload);
                        //         console.log('API Response:', res.data);
                        //         if (res.data.response_code === 200) {
                        //             toast.success(res.data.response_msg);
                        //             setFormData(res.data.response_data);
                        //         } else {
                        //             toast.error(res.data.response_msg);
                        //         }
                        //     } catch (error) {
                        //         console.error('Error saving shipment record:', error);
                        //     }

                        // } else {
                        const newFiles = filesWithBase64.map((obj) => obj.file);
                        let newBase64Files;
                        if (pos === 'C') {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                        } else {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        }
                        console.log('newBase64Files', newBase64Files);

                        // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                        // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                        setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                        setBase64Files(mergedBase64Files);
                        if (pos == 'R') {
                            setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
                            setSendData((prevFormData) => {
                                // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                                const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                                return newFormData;
                            });
                        }

                        // }
                    }
                };
                reader.readAsDataURL(file);
            });
        } else {
            toast.error('Please add AwbNumber first')
        }

    };
    const imageUpload = async () => {
        // setGridSelect(prevGridSelect =>
        //     prevGridSelect.map(item => {
        //         if (item.uid === selectedRowId) {
        //             return { ...item, files: files, base64Files: base64Files };
        //         }
        //         return item;
        //     })
        // );
        // setShowModalUpload(false);
        const payload = {
            shipmen_id: formData.id,
            shipmen_type: "import",
            attachments: base64Files
        }
        // console.log('payload', payload);
        try {
            const res = await withRFSToken.post('shipment/upload-doc', payload);
            console.log('API Response:', res.data);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                // setFormData(res.data.response_data);
                fetchUser(shId);
                setShowModalUpload(false);
                setFiles([])
                setUploadTarget('');
                setBase64Files([]);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
    };
    const [hawbEdited, setHawbEdited] = useState(() => {
        return !!localStorage.getItem("SHEdit");
    }); // to track if someone has edited the hawb or not 

    const handleInputChange = (name, value) => {
        if (name === "master_airwaybill") {
            const formattedValue = handleChange(value);
            setFormData(prev => ({
                ...prev,
                master_airwaybill: formattedValue,
                hawb: hawbEdited ? prev.hawb : formattedValue
            }));
            return;
        }
        if (name === "hawb") {
            setHawbEdited(true);
        }
        if (name === "ata") {
            setFormData(prev => ({
                ...prev,
                ata: value,
                flight_details: prev.flight_details.map(fd => ({ ...fd, ata: value }))
            }));
            return;
        }
        if (name === "origin") {
            setFormData(prev => ({
                ...prev,
                flight_details: prev.flight_details.map((fd, index) =>
                    index === 0 ? { ...fd, origin: value } : fd
                )
            }));
            return;
        }
        if (name == "shipper" || name == "shipper_id") {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
            return;
        }
        if (name === "consignee" || name === "consignee_id") {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [submitSection, setSubmitSection] = useState('');

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const saveShipmentRecord = async (pos) => {
        // const twoStepsComplete = checkStepsStatus(formData, [1, 2]);
        setIsEditable(false);
        setDisLoading(true)
        let payload = {};
        const invoiceData = updateInvoices?.length ? updateInvoices : formData.invoices
        const { customer_address, ...filteredFormData } = formData;
        // if (twoStepsComplete) {
        if (selectedButton === 'remarks') {
            //if (activeStep === 2) {
            payload = { ...filteredFormData, remarks: sendData, health_inspection: '1', invoices: invoiceData };
        } else {
            payload = { ...filteredFormData, health_inspection: '1', invoices: invoiceData };
        }
        // } else {
        //     //payload = { ...formData, health_inspection: '0' };
        //     toast.error("Complete Step 1 and Step 2 to submit.");
        //     return;
        // }


        try {
            const res = await withRFSToken.post('shipment/save-import-shipment-record', payload);

            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                if (pos == 'S') {

                    fetchUser(editRecordId);
                } else if (pos == 'A') {
                    window.location.href = localStorage.getItem('ccbackUrl');
                } else {
                    if (editRecordId) { fetchUser(editRecordId) } else { fetchUser() }
                    setRfiles([]);
                    setSendData({});
                }
                // else{window.location.reload();setSelectedButton('remarks')}
                setIsEditable(false);
            } else {
                toast.error(res.data.response_msg);
                setIsEditable(true);
                setDisLoading(false)
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
            toast.error('An error occurred while saving the shipment record');
        }
    };
    const handleConfirmSubmit = async () => {
        setVwaFilled(false); // Close the modal
        // setFormData(prev => ({
        //     ...prev,
        //     health_inspection: 0
        // }));
        await saveShipmentRecord(submitSection); // Proceed with the API call
    };
    const validateFormData = () => {
        if (!formData?.master_airwaybill) {
            toast.error('Please add Master Airwaybill first');
            return false;
        }

        if (!formData?.e_pcs) {
            toast.error('Please add Expected Pcs');
            return false;
        }

        return true;
    };
    const handleSubmit = async (pos) => {
        if (!validateFormData()) {
            return;
        }
        const twoStepsComplete = checkStepsStatus(formData, [1, 2]);
        const isHealthInspection = formData?.health_inspection == "1";
        if (isHealthInspection) {
            if (!twoStepsComplete) {
                toast.error("Complete Step 1 and Step 2 in vwa tab to submit.");
                return;
            }
            setSubmitSection(pos);
            const allStepsComplete = checkStepsStatus(formData);

            if (allStepsComplete) {
                setVwaFilled(true);
            } else {
                setVwaFilled(false); saveShipmentRecord(pos);
            }
        } else {
            setVwaFilled(false);
            saveShipmentRecord(pos);
        }
    };

    const [typeModal, setTypeModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');

    const handleOpenModal = (pos, data) => {
        setModalData(data);
        setTypeModal(true);
        setModalSection(pos);
        setTypeData(data.category[0])
    }
    const modalChange = (e) => {
        setTypeData(e.target.value);
    }
    const modalUpdate = async () => {
        if (modalSection === 'S') {
            if (typeData !== null) {
                const payload = {
                    shipmen_id: shId,
                    shipmen_type: 'import',
                    action_type: 'update',
                    file_id: modalData.file_id,
                    category: [typeData]
                }
                // console.log(payload);
                try {
                    const res = await withRFSToken.post('shipment/update-doc', payload);
                    if (res.data.response_code === 200) {
                        // setFormData(res.data.response_data);
                        fetchUser(shId);
                        toast.success(res.data.response_msg)
                        setTypeModal(false);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            } else {
                toast.error('Please change the type first')
            }
        } else {
            const payload = {
                shipmen_id: shId,
                shipmen_type: 'import',
                action_type: 'delete',
                file_id: modalData.file_id
            }
            // console.log(payload);
            try {
                const res = await withRFSToken.post('shipment/update-doc', payload);
                if (res.data.response_code === 200) {
                    // setFormData(res.data.response_data);
                    fetchUser(shId);
                    toast.success(res.data.response_msg)
                    setTypeModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        }

    }
    const addFlight = () => {
        setFormData(prevFormData => {
            const lastId = prevFormData.flight_details.length > 0
                ? parseInt(prevFormData.flight_details[prevFormData.flight_details.length - 1].id)
                : 0;

            const newId = (lastId + 1).toString();

            return {
                ...prevFormData,
                flight_details: [
                    ...prevFormData.flight_details,
                    { id: newId, flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', eta: '', ata: prevFormData.ata || '' }
                ]
            };
        });
    };


    const removeFlight = (dimensionId) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                flight_details: prevFormData.flight_details.filter(stack => stack.id !== dimensionId)
            };
        });
    };
    const handleFlChange = (flightId, fieldName, value) => {
        setFormData(prevFormData => {
            let updatedFlights = prevFormData.flight_details.map(stack => {
                if (stack.id === flightId) {
                    if (fieldName === 'flight_code') {
                        const selectedOwner = getOwnerCodes.find(option => option.value === value);
                        return {
                            ...stack,
                            flight_code: value,
                            airline_name: selectedOwner ? selectedOwner.airline_name : ''
                        };
                    }
                    return { ...stack, [fieldName]: value };
                }
                return stack;
            });

            if (fieldName === 'ata') {
                updatedFlights = updatedFlights.map(f => ({ ...f, ata: value }));
                return {
                    ...prevFormData,
                    flight_details: updatedFlights,
                    ata: value
                };
            }

            return {
                ...prevFormData,
                flight_details: updatedFlights
            };
        });
    };


    // Add this state for tab selection
    const [selectedTab, setSelectedTab] = useState('details');

    // 3. Modal for Health Inspection
    const [showHealthModal, setShowHealthModal] = useState(false);
    const [pendingHealthValue, setPendingHealthValue] = useState(null);

    const handleHealthInspectionChange = (value) => {
        if (value === "1" && formData.health_inspection !== "1") {
            setPendingHealthValue(value);
            setShowHealthModal(true);
        } else {
            handleInputChange('health_inspection', value);
        }
    };
    const confirmHealthModal = () => {
        handleInputChange('health_inspection', pendingHealthValue);
        setShowHealthModal(false);
        setSelectedTab('vwa');
    };
    const cancelHealthModal = () => {
        handleInputChange('health_inspection', '0');
        setShowHealthModal(false);
    };
    const isStepComplete = (stepName) => {
        switch (stepName) {
            case 'eta':
                return formData.eta && formData.eta.trim() !== '';
            case 'ata':
                return formData.ata && formData.ata.trim() !== '';
            case 'noa':
                return formData.noa && formData.noa.trim() !== '';
            case 'pickup':
                return formData.pickup_airline && formData.pickup_airline.trim() !== '';
            case 'warehouseIn':
                return formData.warehouse_in && formData.warehouse_in.trim() !== '';
            case 'warehouseOut':
                return formData.warehouse_out && formData.warehouse_out.trim() !== '';
            default:
                return false;
        }
    };

    const handleAddLocation = () => {
        setAddLocationModal(true);
    }

    const hideLocationModal = () => {
        setAddLocationModal(false);
        setLocationData({});
    }

    const handleLocationChange = (name, value) => {
        setLocationData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleLocationSave = async () => {
        if (!locationData.station || !locationData.location) {
            toast.success("Please fill all required fields.");
            return;
        }
        const payload = {
            ...(locationData?.id && { id: locationData?.id }),
            station: locationData.station,
            location: locationData.location
        };
        try {
            const res = await withRFSToken.post('forwarder-location/save', payload);
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                window.$(lgridRef.current).jqxGrid('updatebounddata');
                setAddLocationModal(false);
                setLocationData({});
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const handleLinkClick = async (fn, e) => {
        if (fn == 'expected') {
            initializeAcceptanceForm();
            await fetchLocation();
            setAcceptanceModal(true);
        }
        else if (fn == 'instock') {
            if (formData.inspection_status === "on_hold" || formData.inspection_status === "rejected") {
                toast.error("Cannot release when Inspection Status is On Hold or Rejected");
                return;
            }
            initializeReleaseForm();
            await loadCompany();
            setReleaseModal(true);
        } else if (fn == 'deliver') {
            initializeDeliverForm();
            await loadCompany();
            setDeliverModal(true);
        } else {
            const localData = JSON.parse(localStorage.getItem('SHEdit'));
            fetchMovementLog(localData, e === 'first' ? 'in_stock' : e === 'second' ? 'delivered' : e);
            //setDetailsModal(true);
        }
    }


    const [invoiceDetails, setInvoiceDetails] = useState([]);

    const contactModalOpen = () => {
        setContactModal(true)
    }
    const locationModalOpen = () => {
        setIsLoadingl(false);
        setLgridData({ Active: {} });
        setLocationModal(true)
    }

    const handleCustomerApply = () => {
        if (gridSelect.length == 0) {
            toast.error('Please select at least one customer')
        } else if (gridSelect.length == 1) {
            setContactModal(false);
            setFormData(prevData => ({
                ...prevData,
                customer_id: gridSelect[0].id,
                customer_name: gridSelect[0].name + ' - ' + gridSelect[0].customer_type,
                customer_address: gridSelect[0].address || ''
            }));
            setGridSelect([]);
        } else {
            toast.error('You can select one customer at a time')
        }
    }
    const handleLocationApply = () => {
        if (gridSelect.length == 0) {
            toast.error('Please select at least one customer')
        } else if (gridSelect.length == 1) {
            setLocationModal(false);
            setFormData(prevData => ({
                ...prevData,
                location: gridSelect[0].location
                // customer_id: gridSelect[0].id,
                // customer_name: gridSelect[0].name + ' - ' + gridSelect[0].customer_type
            }));
            setGridSelect([]);
        } else {
            toast.error('You can select one customer at a time')
        }
    }
    const handleTabsClick = (tab) => {
        setSelectedTab(tab);
        setSelectedButton('general')
    }
    const handleInvoice = (rows) => {
        // console.log('savedRows', rows);
        setUpdateInvoices(rows)
    }
    const handleSelect = (row) => {
        console.log('savedRows', row);
        setGridSelect(row)
    }

    return (
        <>
            {console.log('formData', formData)}
            {/* {console.log('vatRows', vatRows)} */}
            <style>
                {`
          .jqx-popup,
          .jqx-listbox-container,
          .jqx-menu-dropdown {
            z-index: 9999 !important;
          }
        `}
                <Modal show={contactModal} onHide={() => setContactModal(false)} className='addfrom add_category_modal' centered size='xl'>
                    <Modal.Header closeButton>
                        <Modal.Title>Contact Finder</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Customer
                            isModal={true}
                            onSelect={handleSelect}
                        />
                    </Modal.Body>
                    <Modal.Footer className='justify-content-center'>
                        <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                            <Button variant="secondary" onClick={() => setContactModal(false)}>Cancel</Button>
                            <Button type="button" className="btn btn-primary" onClick={handleCustomerApply}>Apply</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </style>
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className='shipment_tab'>
                <div className="mt-3 ">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="viewbooks viewbook" style={{ height: "125px" }}>
                                <h4 className="d-flex align-items-center justify-content-between">
                                    Import Record - {formData.cargohub_id}
                                </h4>
                                <div className='d-flex'>
                                    <div className='w-50 lft_prt'>
                                        <p className="info-row">
                                            <span className="label">Status </span>
                                            <span className="value status">
                                                : {shId && formData?.stock_status}
                                            </span>
                                        </p>

                                        <p className="info-row">
                                            <span className="label">Created </span>
                                            <span className="value">
                                                : {formData?.created_at?.split('T')[0].split('-').reverse().join('-')}
                                            </span>
                                        </p>



                                        <p className="info-row">
                                            <span className="label">Location </span>
                                            <span className="value">: {shId && formData.location}</span>
                                        </p>


                                    </div>
                                    <div className='w-50 rght_prt'>
                                        <p className="info-row">
                                            <span className="label">In Stock Pieces </span>
                                            <span className="value">
                                                : {formData.actual_hawb_pieces}
                                            </span>
                                        </p>
                                        <p className="info-row">
                                            <span className="label">Weight </span>
                                            <span className="value">: {shId && formData.e_weight}</span>
                                        </p>
                                        <p className="info-row">
                                            <span className="label">Temp </span>
                                            <span className="value">: {shId && formData.temparature}</span>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="viewbooks" style={{}}>
                                {/* Progress Bar */}
                                <div className="mt-1">
                                    <div className="d-flex justify-content-between align-items-start position-relative">

                                        <div className="Progress_Line" style={{ backgroundColor: '#ccc' }}></div>
                                        {/* Step 1 - ETA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('eta') ? "step_complete" : "step_incomplete"} style={{}}>
                                                1
                                            </div>
                                            <div className={isStepComplete('eta') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>ETA</div>
                                                <div>{formData.eta ? formData.eta.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 2 - ATA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('ata') ? "step_complete" : "step_incomplete"} style={{}}>
                                                2
                                            </div>
                                            <div className={isStepComplete('ata') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>ATA</div>
                                                <div>{formData.ata ? formData.ata.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 3 - NOA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('noa') ? "step_complete" : "step_incomplete"} style={{}}>
                                                3
                                            </div>
                                            <div className={isStepComplete('noa') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>NOA</div>
                                                <div>{formData.noa ? formData.noa.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 4 - Pickup Airline */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('pickup') ? "step_complete" : "step_incomplete"} style={{}}>
                                                4
                                            </div>
                                            <div className={isStepComplete('pickup') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>Pickup Airline</div>
                                                <div>{formData.pickup_airline || ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 5 - Warehouse In */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('warehouseIn') ? "step_complete" : "step_incomplete"} style={{}}>
                                                5
                                            </div>
                                            <div className={isStepComplete('warehouseIn') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt'}>
                                                <div>Warehouse In</div>
                                                <div>{formData.warehouse_in || ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 6 - Warehouse Out */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('warehouseOut') ? "step_complete" : "step_incomplete"} style={{}}>
                                                6
                                            </div>
                                            <div className={isStepComplete('warehouseOut') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt'}>
                                                <div>Warehouse Out</div>
                                                <div>{formData.warehouse_out || ''}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Row className='mt-3'>
                    <Col sm='3'>
                        <div className='add_shipment'>
                            <button className={selectedButton === 'general' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('general')}>
                                <img src={selectedButton === 'general' ? AssetsIconw : AssetsIcon} /> <span>General</span>
                            </button>
                            <button className={selectedButton === 'attachment' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('attachment')}>
                                <img src={selectedButton === 'attachment' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                            </button>
                            <button className={selectedButton === 'remarks' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('remarks')}>
                                <img src={selectedButton === 'remarks' ? AssetsIconw : AssetsIcon} /> <span>Remarks ({formData?.remarks?.length || 0})</span>
                            </button>
                        </div>

                        {/* {console.log('modalData', formData)}
                        {console.log('typeData', typeData)}
                        {console.log('activeStep', activeStep)} */}
                        {selectedButton === 'general' &&
                            <>
                                <div className='flbg mt-4 ra_label'>
                                    <div className="ship_head">
                                        <h4>Update Status</h4>
                                    </div>
                                    <Form.Group className="mb-2">
                                        <Form.Label>Cargohub ID </Form.Label>
                                        <Select
                                            // options={userList}
                                            onChange={(selected) => {
                                                setFormData({
                                                    ...formData,
                                                    assigned_to: selected.value
                                                });
                                            }}
                                            placeholder="Cargohub ID"
                                            className='rfs_autoslct'
                                            name="assigned_to"
                                        // value={formData.assigned_to
                                        //     ? userList.find(option => option.value === formData.assigned_to)
                                        //     : null}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-2">
                                        <Form.Label>Assigned User </Form.Label>
                                        <Select
                                            options={userList}
                                            onChange={(selected) => {
                                                setFormData({
                                                    ...formData,
                                                    assigned_to: selected.value
                                                });
                                            }}
                                            placeholder="User"
                                            className='rfs_autoslct'
                                            name="assigned_to"
                                            value={formData.assigned_to
                                                ? userList.find(option => option.value === formData.assigned_to)
                                                : null}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-2">
                                        <Form.Label>Status Record</Form.Label>
                                        <Select
                                            options={statusList}
                                            onChange={(selected) => {
                                                setFormData({
                                                    ...formData,
                                                    setting_status: selected.value
                                                });
                                            }}
                                            placeholder="Status"
                                            className='rfs_autoslct'
                                            name="setting_status"
                                            value={formData.setting_status
                                                ? statusList.find(option => option.value === formData.setting_status)
                                                : null}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-2">
                                        <Form.Label>Department </Form.Label>
                                        <Select
                                            options={departmentList}
                                            onChange={(selected) => {
                                                setFormData({
                                                    ...formData,
                                                    setting_department: selected.value
                                                });
                                            }}
                                            placeholder="Department"
                                            className='rfs_autoslct'
                                            name="setting_department"
                                            value={formData.setting_department
                                                ? departmentList.find(option => option.value === formData.setting_department)
                                                : null}
                                        />
                                    </Form.Group>
                                </div>
                                <div className='flbg mt-4 ra_label'>
                                    <div className="ship_head">
                                        <h4>Delivery Details</h4>
                                    </div>
                                    <div className='mb-2 tab_design'>
                                        <button className={`exportbtn me-2${deliveryTab === 'in_stock' ? ' active' : ''}`} onClick={() => setDeliveryTab('in_stock')}>
                                            In Stock
                                        </button>
                                        <button className={`exportbtn me-2${deliveryTab === 'released' ? ' active' : ''}`} onClick={() => setDeliveryTab('released')}>
                                            Release
                                        </button>
                                        <button className={`exportbtn me-2${deliveryTab === 'delivered' ? ' active' : ''}`} onClick={() => setDeliveryTab('delivered')}>
                                            Delivered
                                        </button>
                                        <button className={`exportbtn me-2${deliveryTab === 'archived' ? ' active' : ''}`} onClick={() => setDeliveryTab('archived')}>
                                            Archived
                                        </button>
                                    </div>
                                    <div>
                                        {deliveryTab === 'in_stock' &&
                                            <>
                                                {formData.movements?.filter(mt => mt.stage === 'in_stock')?.map((item, index) => (
                                                    <div className="hawb_pic_list mt-2">
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    <span>InStock Date : {item.moved_at.split(' ')[0] || '-'}</span>
                                                                    <span>InStock Time : {item.moved_at.split(' ')[1] || '-'}</span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                    Accepted Pcs : {item.pieces_moved}
                                                                </span>
                                                                <span>Stage : {item.stage}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                        {deliveryTab === 'released' &&
                                            <>
                                                {formData.movements?.filter(mt => mt.stage === 'released')?.map((item, index) => (
                                                    <div className="hawb_pic_list mt-2">
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    <span>InStock Date : {item.moved_at.split(' ')[0] || '-'}</span>
                                                                    <span>InStock Time : {item.moved_at.split(' ')[1] || '-'}</span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                    Released Pcs : {item.pieces_moved}
                                                                </span>
                                                                <span>Stage : {item.stage}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                        {deliveryTab === 'delivered' &&
                                            <>
                                                {formData.movements?.filter(mt => mt.stage === 'delivered')?.map((item, index) => (
                                                    <div className="hawb_pic_list mt-2">
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    <span>InStock Date : {item.moved_at.split(' ')[0] || '-'}</span>
                                                                    <span>InStock Time : {item.moved_at.split(' ')[1] || '-'}</span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                    Delivered Pcs : {item.pieces_moved}
                                                                </span>
                                                                <span>Stage : {item.stage}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                        {deliveryTab === 'archived' &&
                                            <>
                                                {formData.in_archive_details?.map((item, index) => (
                                                    <div className="hawb_pic_list mt-2">
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    <span>Archived Date : {item?.date_time?.split(' ')[0] || '-'}</span>
                                                                    <span>Archived Time : {item?.date_time?.split(' ')[1] || '-'}</span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                    Archived Pcs : {item.total_pcs}
                                                                </span>
                                                                <span>Stage : Archived</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </>
                                        }
                                    </div>
                                    {/* <div>
                                        {isLoadingDelivery && (
                                            <div className="hawb_pic_list mt-2"><ul><li><p>Loading...</p></li></ul></div>
                                        )}
                                        {!isLoadingDelivery && deliveryLogs?.length === 0 && (
                                            <div className="hawb_pic_list mt-2"><ul><li><p>No records available.</p></li></ul></div>
                                        )}
                                        {!isLoadingDelivery && deliveryLogs?.map((log, index) => {
                                            const [date, time] = (log.moved_at || '').split(' ');
                                            const labels = {
                                                delivered: { date: 'Delivered Date', time: 'Delivered Time' },
                                                in_stock: { date: 'InStock Date', time: 'InStock Time' },
                                                released: { date: 'Released Date', time: 'Released Time' },
                                                default: { date: 'Updated Date', time: 'Updated Time' },
                                            };
                                            const { date: dateLabel, time: timeLabel } = labels[log.stage] || labels.default;
                                            return (
                                                <div key={index} className="hawb_pic_list mt-2">
                                                    <ul>
                                                        <li>
                                                            <p>
                                                                <span>{dateLabel} : {date || '-'}</span>{' '}
                                                                <span>{timeLabel} : {time || '-'}</span>
                                                            </p>
                                                        </li>
                                                        <li>
                                                            {log.stage !== 'in_stock' && (
                                                                <span>Pcs Picked : {log.picked_pcs}</span>
                                                            )}
                                                            <span>
                                                                {log.stage === 'in_stock' ? 'Accepted Pcs' : log.stage === 'released' ? 'Released Pcs' : 'Delivered Pcs'} : {log.pieces_moved}
                                                            </span>
                                                            <span>Stage : {log.stage}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            );
                                        })}
                                    </div> */}
                                </div>
                                {hasSHEdit &&
                                    <div>
                                        <div className='flbg mt-4 ra_label'>
                                            <div className="ship_head">
                                                <h4>Message Log</h4>
                                            </div>
                                            <div className='mb-2 tab_design'>
                                                <button className={`exportbtn me-2${activeMsgTab === 'In' ? ' active' : ''}`} onClick={() => handleMsgTabChange('In')}>
                                                    In
                                                </button>
                                                <button className={`exportbtn me-2${activeMsgTab === 'Out' ? ' active' : ''}`} onClick={() => handleMsgTabChange('Out')}>
                                                    Out
                                                </button>
                                            </div>

                                            {activeMsgTab === "In" && (
                                                <div>
                                                    {formData?.movements
                                                        ?.filter(movement => movement.stage === "in_stock")
                                                        .map((movement) => (
                                                            <div key={movement.id}>
                                                                {movement.cargonaut_messages?.map((msg) => (
                                                                    <p key={msg.id} className="side_log_msg">
                                                                        {msg.message}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        ))}
                                                </div>
                                            )}

                                            {activeMsgTab === "Out" && (
                                                <div>
                                                    {formData?.movements
                                                        ?.filter(movement => movement.stage === "delivered")
                                                        .map((movement) => (
                                                            <div key={movement.id}>
                                                                {movement.cargonaut_messages?.map((msg) => (
                                                                    <p key={msg.id} className="side_log_msg">
                                                                        {msg.message}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        ))}
                                                </div>
                                            )}
                                        </div>
                                        {/* <Tabs defaultActiveKey={activeMsgTab} onSelect={(tab) => handleMsgTabChange(tab)} id="station-tabs" className="station_grid">
                                        <Tab eventKey="In" title={<span>In</span>} className='moveto'>
                                            <div className='mt-4'>
                                                {formData?.movements?.map((movement) => (
                                                    <div>
                                                        {movement.cargonaut_messages.map((msg) => (
                                                            <p className='side_log_msg'>{msg.message}</p>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </Tab>
                                        <Tab eventKey="Out" title={<span>Out</span>} className='moveto'>
                                            <div className='mt-4'>
                                                {formData?.movements?.map((movement) => (
                                                    <div>
                                                        {movement.cargonaut_messages.map((msg) => (
                                                            <p className='side_log_msg'>{msg.message}</p>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </Tab>
                                    </Tabs> */}

                                    </div>
                                }
                            </>
                        }

                        {selectedButton === 'attachment' &&
                            <div className='flbg mt-4'>

                                <div className="ship_head">
                                    <h4>Document Checklist</h4>
                                </div>
                                <ul className="dock_check">
                                    {["Handling form",
                                        "MAWB",
                                        "HAWB",
                                        "Packinglist",
                                        "Invoice",
                                        "Inspection reports",
                                        "Customs declarations, IM4, T1",
                                        "Delivery slips",
                                        "Emails",
                                        "Other"
                                    ].map((name) => (
                                        <li key={name}>
                                            <span>
                                                <Form.Check
                                                    inline
                                                    label={name}
                                                    value={name}
                                                    // id={name}
                                                    name="group1"
                                                    // readOnly
                                                    // onChange={handleChecklicstChange}
                                                    checked={formData?.attachments?.some(chk => chk.category && chk.category.includes(name)) || false}
                                                />
                                            </span>
                                            <span>
                                                {/* <img src={Uploadn} onClick={(e) => handleBrowseFiles(e, name)} /> */}
                                                <img src={Uploadn} onClick={() => { setUploadTarget(name); setShowModalUpload(true); }} />
                                                {/* <input
                                                    type="file"
                                                    ref={(el) => (fileInputRefs.current[name] = el)}
                                                    style={{ display: "none" }}
                                                    name={name}
                                                    onChange={(e) => handleFileChange(e, "C", name)}
                                                    multiple
                                                /> */}
                                            </span>
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        }
                    </Col>
                    <Col sm='9'>
                        <div className='mb-3 position-relative'>
                            <button className={`exportbtn me-3${selectedTab === 'details' ? ' active' : ''}`} onClick={() => handleTabsClick('details')}>
                                <img src={selectedTab === 'details' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
                            </button>
                            <button className={`exportbtn me-3${selectedTab === 'vwa' ? ' active' : ''}`} onClick={() => handleTabsClick('vwa')}>
                                <img src={selectedTab === 'vwa' ? AssetsIconw : AssetsIcon} /> <span>VWA</span>
                            </button>
                            <button className={`exportbtn me-3${selectedTab === 'customs' ? ' active' : ''}`} onClick={() => handleTabsClick('customs')}>
                                <img src={selectedTab === 'customs' ? AssetsIconw : AssetsIcon} /> <span>Customs</span>
                            </button>
                            <button className={`exportbtn me-3${selectedTab === 'invoice' ? ' active' : ''}`} onClick={() => handleTabsClick('invoice')}>
                                <img src={selectedTab === 'invoice' ? AssetsIconw : AssetsIcon} /> <span>Invoice</span>
                            </button>

                            {/* <span className='forwd_submit'><button onClick={() => handleSubmit('S')}><FontAwesomeIcon icon={shId ? faPencilAlt : faPaperPlane} className='pe-1' />{shId ? 'Update' : 'Submit'}</button></span> */}
                            <span className="forwd_submit">
                                <button onClick={() => window.location.href = localStorage.getItem('ccbackUrl')} className="stk_close">
                                    <FontAwesomeIcon icon={faTimes} /> Close
                                </button>

                                {(selectedTab != 'invoice' || (selectedTab == 'invoice' && isEditable)) &&
                                    <button
                                        onClick={() => {
                                            if (shId) {
                                                if (isEditable) {
                                                    handleSubmit("S"); // Update
                                                } else {
                                                    setIsEditable(true); // Switch to edit mode
                                                }
                                            } else {
                                                handleSubmit("A"); // Normal Submit
                                            }
                                        }}
                                        className='stk_view'
                                    >
                                        <FontAwesomeIcon
                                            icon={shId ? (isEditable ? faPaperPlane : faPencilAlt) : faPaperPlane}
                                            className=""
                                        />
                                        {shId ? (isEditable ? "Update" : "Edit") : "Submit"}

                                    </button>
                                }
                            </span>




                        </div>
                        {/* Content area below the buttons, changes based on selectedTab */}
                        {(selectedButton === 'general' && selectedTab === 'vwa') &&
                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Create File</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                            {/* <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                shipment_type: formData.shipment_type,
                                                master_airwaybill: formData.master_airwaybill,
                                                hawb: formData.hawb,
                                                type_of_goods: formData.type_of_goods,
                                                e_pcs: formData.e_pcs,
                                                e_weight: formData.e_weight,
                                              })}`} /><b>Step 1</b></p> */}
                                            <p>
                                                {/* <FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                shipment_type: formData.shipment_type,
                                                master_airwaybill: formData.master_airwaybill,
                                                hawb: formData.hawb,
                                                type_of_goods: formData.type_of_goods,
                                                e_pcs: formData.e_pcs,
                                                e_weight: formData.e_weight,
                                                customer_id: formData.customer_id
                                            }, formData.flight_details)} , true`} /> */}
                                                <FontAwesomeIcon icon={faCircle} className={`pe-2 ${getSectionStatus(step1)}`} />
                                                <b>Step 1</b></p>
                                        </div>
                                        <ul className="list-unstyled">
                                            <li>
                                                <span>Master AirwayBill: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="master_airwaybill"
                                                        value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipment Type: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={TransportShipmentType}
                                                        name="shipment_type"
                                                        className="autoslct"
                                                        value={TransportShipmentType.find(opt => opt.value === formData.shipment_type) || ''}
                                                        onChange={(e) => handleInputChange('shipment_type', e.value)}
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipment Class: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={VwsShipmentClass}
                                                        name="shipment_class"
                                                        className="autoslct"
                                                        value={VwsShipmentClass.find(opt => opt.value === formData.shipment_class) || ''}
                                                        onChange={(e) => handleInputChange('shipment_class', e.value)}
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Incoterm :</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li> */}


                                            <li>
                                                <span>HAWB: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="hawb"
                                                        value={formData.hawb}
                                                        onChange={(e) => handleInputChange('hawb', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Type of goods: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="type_of_goods"
                                                        value={formData.type_of_goods}
                                                        onChange={(e) => handleInputChange('type_of_goods', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Country Code: </span>
                                                <span>
                                                    <Select
                                                        options={countryCode}
                                                        onChange={(e) => handleInputChange('country_code', e.value)}
                                                        placeholder="Country Code"
                                                        className="autoslct"
                                                        name="country_code"
                                                        value={countryCode.find(option => option.value === formData?.country_code) || ''}
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Expected Pcs: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="number"
                                                        name="e_pcs "
                                                        value={formData.e_pcs}
                                                        onChange={(e) => handleInputChange('e_pcs', e.target.value)}
                                                        disabled={!isEditable || disablePcs}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Expected Weight: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="number"
                                                        name="e_weight"
                                                        value={formData.e_weight}
                                                        onChange={(e) => handleInputChange('e_weight', e.target.value)}
                                                        disabled={!isEditable || disablePcs}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Temperature :</span>
                                                <span>
                                                    <Form.Control
                                                        type="number"
                                                        name="temparature"
                                                        value={formData.temparature}
                                                        onChange={(e) => handleInputChange('temparature', e.target.value)}
                                                    />
                                                </span>
                                            </li> */}

                                            <li>
                                                <span>Customer: <span className="text-danger">*</span></span>
                                                {/* <span>
                                                    <Select
                                                        options={customerOptions}
                                                        onChange={(e) => handleInputChange('customer_id', e.value)}
                                                        value={customerOptions.find(opt => opt.value === formData.customer_id) || ''}
                                                        className="w-100"
                                                        placeholder="--"
                                                    />
                                                </span> */}
                                                <span className='d-inline-flex'>
                                                    <Form.Control type="text" name="customer" className='flex-shrink-1' value={formData.customer_name} disabled />
                                                    <Button className='flex-grow-1 ms-2 customer_icon' onClick={contactModalOpen} disabled={!isEditable}><FontAwesomeIcon icon={faUser} /></Button>
                                                </span>
                                            </li>
                                            <li>
                                                <span></span>
                                                {/* <span className='text-end mt-2 dimension_add'><Button variant="primary" onClick={handleAddCustomer} >+ Add Customer</Button></span> */}
                                            </li>
                                        </ul>
                                        <div className='ship_head'>
                                            <h4>Flight Details </h4>
                                            {/* <Link to='#'>edit</Link> */}
                                            {/* <div className='text-end mt-2 dimension_add'>
                                                <Button variant="primary" onClick={handleAddCustomer} >+ Add Customer</Button>
                                            </div> */}
                                        </div>

                                        {formData?.flight_details?.map((data, index) => (
                                            <>
                                                <div className='flight_section mb-3'>
                                                    <div className='flex_gap'>
                                                        <h4>Flight {index + 1}</h4>
                                                        <div className='imag_trash ms-0 mt-0 align-items-center'>
                                                            {formData.flight_details.length > 1 && (
                                                                <img src={Trash} alt='' onClick={() => removeFlight(data.id)} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <span>Airline Name: <span className="text-danger">*</span></span>
                                                            <span>
                                                                {/* <Form.Control type="text" name="airline_name" value={data.airline_name}
                                                                    onChange={e => handleFlChange(data.id, 'airline_name', e.target.value)}  
                                                                 /> */}
                                                                <Form.Control
                                                                    type="text"
                                                                    name="airline_name"
                                                                    value={data.airline_name}
                                                                    disabled={true}
                                                                />
                                                            </span>
                                                        </li>
                                                    </ul>

                                                    <div className='flex_gap'>
                                                        <div>
                                                            <Form.Label>Flight Number <span className="text-danger">*</span></Form.Label>
                                                            <div className='flex_gap'>
                                                                <Select
                                                                    options={getOwnerCodes}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_code', e.value)}
                                                                    placeholder="flight"
                                                                    className="autoslct"
                                                                    name="flight_code"
                                                                    value={getOwnerCodes.find(option => option.value === data?.flight_code) || ''}
                                                                    isDisabled={!isEditable}
                                                                />
                                                                <Form.Control type="text" className='fl_wd' placeholder="" value={data.flight_number}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_number', e.target.value)} disabled={!isEditable} />
                                                            </div>
                                                        </div>

                                                        {/* <div className='md_flight'>
                                                            <Form.Label>Flight Date <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="date" placeholder="" value={data.flight_date}
                                                                onChange={(e) => handleFlChange(data.id, 'flight_date', e.target.value)} disabled={!isEditable} />
                                                        </div> */}

                                                        {/* <div className='flight_origin'>
                                                            <Form.Label>Origin </Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'origin', e.value)}
                                                                placeholder="origin"
                                                                className="autoslct"
                                                                name="origin"
                                                                value={getDestination.find(option => option.value === data?.origin) || ''}
                                                                isDisabled={!isEditable}
                                                            />
                                                        </div> */}

                                                        <div className='flight_origin'>
                                                            <Form.Label>Destination <span className="text-danger">*</span></Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'destination', e.value)}
                                                                placeholder="Destination"
                                                                className="autoslct"
                                                                name="destination"
                                                                value={getDestination.find(option => option.value === data?.destination) || ''}
                                                                isDisabled={!isEditable}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='flex_gap'>
                                                        {/* <div className='w-50'>
                                                            <Form.Label>ETD</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={data.etd}
                                                                onChange={(e) => handleFlChange(data.id, 'etd', e.target.value)}
                                                            />
                                                        </div> */}
                                                        {/* <div className='w-50'>
                                                            <Form.Label>ETA</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={data.eta}
                                                                onChange={(e) => handleFlChange(data.id, 'eta', e.target.value)}
                                                            />
                                                        </div> */}
                                                        <div className='w-50'>
                                                            <Form.Label>ATA</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={data.ata}
                                                                onChange={(e) => handleFlChange(data.id, 'ata', e.target.value)}
                                                                disabled={!isEditable}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className='text-end dimension_add'>
                                                    <Button variant="primary p-0" onClick={addFlight} disabled={!isEditable}>+ Add Flight</Button>
                                                </div>
                                            </>
                                        ))}

                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Transport Information</h4>
                                            <p>
                                                {/* <FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                    transport_type: formData.transport_type,
                                                    handler_name: formData.t_handler_org_id,
                                                    delivery_date_time: formData.delivery_date_time,
                                                })}`} /> */}
                                                <FontAwesomeIcon icon={faCircle} className={`pe-2 ${getSectionStatus(step2)}`} />
                                                <b>Step 2</b>
                                            </p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Transport Type: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={TransportOptions}
                                                        onChange={(e) => handleInputChange('transport_type', e.value)}
                                                        value={TransportOptions.find(opt => opt.value === formData.transport_type) || ''}
                                                        className="w-100" placeholder="--" isDisabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handler name: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={getHandler}
                                                        name="t_handler_org_id"
                                                        className="autoslct"
                                                        value={getHandler.find(opt => opt.value === formData.t_handler_org_id) || null}
                                                        onChange={(selectedOption) =>
                                                            handleInputChange('t_handler_org_id', selectedOption ? selectedOption.value : '')
                                                        }
                                                        isDisabled={!isEditable}
                                                    />

                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Delivery date/time: <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_date_time"
                                                        value={formData.delivery_date_time}
                                                        onChange={(e) => handleInputChange('delivery_date_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li> */}
                                            <li>
                                                <span>
                                                    Delivery date: <span className="text-danger">*</span>
                                                </span>
                                                <span>
                                                    <Form.Control
                                                        type="date"
                                                        name="delivery_date"
                                                        value={formData.delivery_date}
                                                        onChange={(e) => handleInputChange('delivery_date', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>
                                                    Delivery time:
                                                </span>
                                                <span>
                                                    <Form.Control
                                                        type="time"
                                                        name="delivery_time"
                                                        value={formData.delivery_time}
                                                        onChange={(e) => handleInputChange('delivery_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Inspection Information</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                no_of_fytos: formData.no_of_fytos,
                                                // inspection_date: formData.inspection_date,
                                                // inspection_start_time: formData.inspection_start_time,
                                                inspection_end_time: formData.inspection_end_time,
                                                inspection_req_time: formData.inspection_req_time,
                                                inspection_conf_time: formData.inspection_conf_time,
                                                inspection_confirm: formData.inspection_confirm,
                                                //inspection_remarks: formData.inspection_remarks,
                                            })}`} /><b>Step 3</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Number of Fyto's:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="no_of_fytos"
                                                        value={formData.no_of_fytos}
                                                        onChange={(e) => handleInputChange('no_of_fytos', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Inspection Date:</span>
                                                <span>
                                                    <Form.Control
                                                        type="date"
                                                        name="inspection_date"
                                                        className="autoslct"
                                                        value={formData.inspection_date}
                                                        onChange={(e) => handleInputChange('inspection_date', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Inspection Time:</span>
                                                <span>
                                                    <Form.Control
                                                        type="time"
                                                        name="inspection_start_time"
                                                        value={formData.inspection_start_time}
                                                        onChange={(e) => handleInputChange('inspection_start_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Requested Time:</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="inspection_req_time"
                                                        value={formData.inspection_req_time}
                                                        onChange={(e) => handleInputChange('inspection_req_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li> */}
                                            <li>
                                                <span>Confirmed Time:</span>
                                                <span>
                                                    <Form.Control
                                                        type="time"
                                                        name="inspection_conf_time"
                                                        value={formData.inspection_conf_time}
                                                        onChange={(e) => handleInputChange('inspection_conf_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>End time:</span>
                                                <span>
                                                    <Form.Control
                                                        type="time"
                                                        name="inspection_end_time"
                                                        value={formData.inspection_end_time}
                                                        onChange={(e) => handleInputChange('inspection_end_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>NVWA Approve :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" id="inspection_confirm-1" name="inspection_confirm" value="true"
                                                        checked={formData?.inspection_confirm == "1"}
                                                        onChange={(e) => handleInputChange('inspection_confirm', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" id="inspection_confirm-2" name="inspection_confirm" value="false"
                                                        checked={formData?.inspection_confirm == "0"}
                                                        onChange={(e) => handleInputChange('inspection_confirm', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Short Remarks:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="inspection_remarks"
                                                        value={formData.inspection_remarks}
                                                        onChange={(e) => handleInputChange('inspection_remarks', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Shipment Arrived</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                shipment_arrived: formData.shipment_arrived,
                                                shipment_arrived_info_shipment_class: formData.shipment_class,
                                            })}`} /><b>Step 4</b></p>
                                        </div>
                                        <ul>
                                            <li className='d-flex'>
                                                <span>Shipment Arrived:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Yes"
                                                        name="shipment_arrived"
                                                        value="true"
                                                        checked={formData.shipment_arrived == "1"}
                                                        id='shipment-arrived-1'
                                                        onChange={(e) => handleInputChange('shipment_arrived', '1')}
                                                        disabled={!isEditable}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label="No"
                                                        name="shipment_arrived"
                                                        value="false"
                                                        checked={formData.shipment_arrived == "0"}
                                                        id='shipment-arrived-2'
                                                        onChange={(e) => handleInputChange('shipment_arrived', '0')}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipment Class:</span>
                                                <span>
                                                    <Select
                                                        options={VwsShipmentClass}
                                                        name="shipment_class"
                                                        className="autoslct"
                                                        value={VwsShipmentClass.find(opt => opt.value === formData.shipment_class) || ''}
                                                        onChange={(e) => handleInputChange('shipment_class', e.value)}
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div> */}
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    {/* warehouse in */}
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Warehouse In</h4>

                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                warehouse_in: formData.warehouse_in,
                                                warehouse_in_doc_type: formData.warehouse_in_doc_type,
                                                warehouse_in_doc_no: formData.warehouse_in_doc_no,
                                                //location: formData.location,
                                                temparature: formData.temparature,
                                                // split_shipment: formData.split_shipment,
                                                // shipment_arrived: formData.shipment_arrived,
                                            })}`} /><b>Step 4</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Date:</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_in"
                                                        value={formData.warehouse_in}
                                                        onChange={(e) => handleInputChange('warehouse_in', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span className='me-0'>DOC Type :</span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="warehouse_in_doc_type"
                                                        className="w-100 autoslct"
                                                        value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === formData.warehouse_in_doc_type) || ''}
                                                        onChange={(e) => handleInputChange('warehouse_in_doc_type', e.value)}
                                                        // isDisabled={!shId}
                                                        isDisabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC No:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="warehouse_in_doc_no"
                                                        value={formData.warehouse_in_doc_no}
                                                        onChange={(e) => handleInputChange('warehouse_in_doc_no', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Location:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="location"
                                                        value={formData.location}
                                                        onChange={(e) => handleInputChange('location', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li> */}
                                            {/* <li>
                                                <span>Temperature:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="temparature"
                                                        value={formData.temparature}
                                                        onChange={(e) => handleInputChange('temparature', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li> */}
                                            {/* <li className='d-flex'>
                                                <span>Split Shipment:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Yes"
                                                        name="split_shipment"
                                                        value="true"
                                                        checked={formData.split_shipment == "1"}
                                                        id='warehouse-out-split-shipment-1'
                                                        onChange={(e) => handleInputChange('split_shipment', '1')}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label="No"
                                                        name="split_shipment"
                                                        value="false"
                                                        checked={formData.split_shipment == "0"}
                                                        id='warehouse-out-split-shipment-2'
                                                        onChange={(e) => handleInputChange('split_shipment', '0')}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li> */}
                                            {/* <li className='d-flex'>
                                                <span>Shipment Arrived: </span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        label="Yes"
                                                        name="shipment_arrived"
                                                        value="true"
                                                        checked={formData.shipment_arrived == "1"}
                                                        id='shipment-arrived-1'
                                                        onChange={(e) => handleInputChange('shipment_arrived', '1')}
                                                        //disabled={!isEditable}
                                                        disabled
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label="No"
                                                        name="shipment_arrived"
                                                        value="false"
                                                        checked={formData.shipment_arrived == "0"}
                                                        id='shipment-arrived-2'
                                                        onChange={(e) => handleInputChange('shipment_arrived', '0')}
                                                        //disabled={!isEditable}
                                                        disabled
                                                    />
                                                </span>
                                            </li> */}
                                            <li>
                                                <span>Temperature :</span>
                                                <div className='d-inline-flex w-75'>
                                                    <Form.Control
                                                        type="number"
                                                        name="temparature"
                                                        value={formData.temparature}
                                                        onChange={(e) => handleInputChange('temparature', e.target.value)}
                                                        // disabled={!isEditable || disabled}
                                                        disabled
                                                        className='me-2'
                                                    />
                                                    <Select
                                                        options={TemperatureOptions}
                                                        onChange={(e) => handleInputChange('temperature_type', e.value)}
                                                        value={TemperatureOptions.find(opt => opt.value === formData.temperature_type) || ''}
                                                        className="w-100" placeholder="--"
                                                        // isDisabled={!isEditable || disabled}
                                                        isDisabled
                                                    />
                                                </div>
                                            </li>
                                        </ul>

                                        <div className='text-end'>
                                            <span >{formData.is_in_stock == 0 && shId && <Link to='#' className="click_update" onClick={() => { handleLinkClick('expected') }}>Acceptance</Link>}</span>
                                        </div>
                                    </div>

                                    {/* inspection status */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Inspection Status</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                inspection_status: formData.inspection_status,
                                                inspection_center: formData.inspection_center,
                                                location: formData.location,
                                            })}`} /><b>Step 5</b></p>
                                        </div>
                                        <ul className='big_radio'>
                                            <li>
                                                <span>Storage Location:</span>
                                                {/* <span>
                                                    <Form.Control type="text" name="location" value={formData.location} onChange={(e) => handleInputChange('location', e.target.value)} disabled = {disabled} />
                                                </span> */}
                                                <span className='d-inline-flex'>
                                                    <Form.Control type="text" name="location" className='flex-shrink-1' value={formData.location} disabled />
                                                    {/* <Button className='flex-grow-1 ms-2' onClick={locationModalOpen} disabled = {disabled}><FontAwesomeIcon icon={faUser}  /></Button> */}
                                                    <Button className='flex-grow-1 ms-2 location_icon' onClick={locationModalOpen} ><FontAwesomeIcon icon={faLocationDot} disabled={!isEditable || disabled} /></Button>
                                                </span>
                                            </li>
                                            <li>
                                                <span>Inspection Centre:</span>
                                                <span className='d-inline-flex'>
                                                    <Select
                                                        options={CentreOptions}
                                                        onChange={(selected) => handleInputChange("inspection_center", selected ? selected.value : "")}
                                                        placeholder="Inspection centre" className="rfs_autoslct" name="inspection_center" isDisabled={!isEditable || disabled}
                                                        value={CentreOptions.find((option) => option.value == formData.inspection_center) || null}
                                                    />
                                                </span>
                                            </li>

                                            <li className='d-flex'>
                                                <span>No Inspection:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        name="inspection_status"
                                                        value="no_inspection"
                                                        checked={formData.inspection_status === "no_inspection"}
                                                        id='no-inspection-1'
                                                        onChange={(e) => handleInputChange('inspection_status', 'no_inspection')}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Approved:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        name="inspection_status"
                                                        value="approved"
                                                        checked={formData.inspection_status === "approved"}
                                                        id='approved-1'
                                                        onChange={(e) => handleInputChange('inspection_status', 'approved')}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>On Hold:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        name="inspection_status"
                                                        value="on_hold"
                                                        checked={formData.inspection_status === "on_hold"}
                                                        id='on-hold-1'
                                                        onChange={(e) => handleInputChange('inspection_status', 'on_hold')}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Rejected:</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio"
                                                        name="inspection_status"
                                                        value="rejected"
                                                        checked={formData.inspection_status === "rejected"}
                                                        id='rejected-1'
                                                        onChange={(e) => handleInputChange('inspection_status', 'rejected')}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            {(formData.inspection_status == "rejected" || formData.inspection_status == 'on_hold' || formData.inspection_status == 'destruction') &&
                                                <li className='d-flex'>
                                                    <span>Release for destruction:</span>
                                                    <span className='d-flex'>
                                                        <Form.Check
                                                            type="radio"
                                                            name="inspection_status"
                                                            value="destruction"
                                                            checked={formData.inspection_status === "destruction"}
                                                            id='destruction-1'
                                                            onChange={(e) => handleInputChange('inspection_status', 'destruction')}
                                                            disabled={!isEditable || disabled}

                                                        />
                                                    </span>
                                                </li>}

                                        </ul>
                                    </div>

                                    {/* release info */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Release Information </h4>

                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                release_id_type: formData.release_id_type,
                                                release_id_number: formData.release_id_number,
                                                release_to: formData.release_to,
                                                released_pcs: formData.released_pcs,
                                                actual_hawb_pieces: formData.actual_hawb_pieces,
                                                // release_carrier_code: formData.release_carrier_code,
                                                release_information_handler_name: formData.r_handler_org_id,
                                            })}`} /><b>Step 6</b></p>
                                        </div>
                                        <ul className='checks'>
                                            <li>
                                                <span>ID Type:</span>
                                                <span>
                                                    <Select
                                                        options={IdTypeOption}
                                                        onChange={(e) => handleInputChange('release_id_type', e.value)}
                                                        value={IdTypeOption.find(
                                                            opt => opt.value === formData.release_id_type
                                                        ) || ''}
                                                        className="w-100"
                                                        placeholder="--"
                                                        isDisabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>ID Number:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="release_id_number"
                                                        value={formData.release_id_number}
                                                        onChange={(e) => handleInputChange('release_id_number', e.target.value)}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Release To:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="release_to"
                                                        value={formData.release_to}
                                                        onChange={(e) => handleInputChange('release_to', e.target.value)}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>In Stock Pieces:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="actual_hawb_pieces"
                                                        value={formData.actual_hawb_pieces}
                                                        onChange={(e) => handleInputChange('actual_hawb_pieces', e.target.value)}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Release Pieces:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="released_pcs"
                                                        value={formData.released_pcs}
                                                        onChange={(e) => handleInputChange('released_pcs', e.target.value)}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Carrier Code:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="release_carrier_code"
                                                        value={formData.release_carrier_code}
                                                        onChange={(e) => handleInputChange('release_carrier_code', e.target.value)}
                                                        disabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li> */}
                                            <li>
                                                <span>Handler Name:</span>
                                                <span>
                                                    <Select
                                                        options={getHandler}
                                                        name="r_handler_org_id"
                                                        className="autoslct"
                                                        value={getHandler.find(opt => opt.value === formData.r_handler_org_id) || null}
                                                        onChange={(selectedOption) =>
                                                            handleInputChange('r_handler_org_id', selectedOption ? selectedOption.value : '')
                                                        }
                                                        isDisabled={!isEditable || disabled}

                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                        <div className='text-end'>
                                            <span>{formData.is_in_release == 0 && shId && <Link to='#' className="click_update" onClick={() => { handleLinkClick('instock') }}>Release</Link>}</span>
                                        </div>
                                    </div>
                                    {/* warehouse out */}
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Warehouse Out</h4>

                                            <p><FontAwesomeIcon icon={faCircle} className={`pe-2 ${getStepStatus({
                                                warehouse_out: formData.warehouse_out,
                                                warehouse_out_doc_type: formData.warehouse_out_doc_type,
                                                warehouse_out_doc_no: formData.warehouse_out_doc_no,
                                            })}`} /><b>Step 7</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Date/Time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_out"
                                                        value={formData.warehouse_out}
                                                        onChange={(e) => handleInputChange('warehouse_out', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Doc Type :</span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="warehouse_out_doc_type"
                                                        className="autoslct"
                                                        value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === formData.warehouse_out_doc_type) || ''}
                                                        onChange={(e) => handleInputChange('warehouse_out_doc_type', e.value)}
                                                        // isDisabled={!shId}
                                                        isDisabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Doc Number :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="warehouse_out_doc_no"
                                                        value={formData.warehouse_out_doc_no}
                                                        onChange={(e) => handleInputChange('warehouse_out_doc_no', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                        <div className='text-end'>
                                            <span>{formData.is_in_deliver == 0 && shId && <Link to='#' className="click_update" onClick={() => { handleLinkClick('deliver') }}>Deliver</Link>}</span>
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                        }
                        {(selectedButton === 'general' && selectedTab === 'customs') && (
                            <div>{/* Customs content here, or leave blank if not needed */}</div>
                        )}
                        {(selectedButton === 'general' && selectedTab === 'invoice') && (
                            <Invoice
                                allData={formData}
                                onDetails={() => setIsEditable(true)}
                                offDetails={() => setIsEditable(false)}
                                onSave={handleInvoice}
                                onEdit={isEditable}
                                loadDetails={() => fetchUser(shId)}
                            />
                        )}
                        {(selectedButton === 'general' && selectedTab == 'details') &&
                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Details</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                        </div>
                                        <ul className="list-unstyled">
                                            <li>
                                                <span className="">Master AirwayBill : <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Expected Pcs : <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control type="number" name="e_pcs" value={formData.e_pcs}
                                                        onChange={(e) => handleInputChange('e_pcs', e.target.value)} disabled={!isEditable || disablePcs} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Expected Weight : <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control type="number" name="e_weight" value={formData.e_weight}
                                                        onChange={(e) => handleInputChange('e_weight', e.target.value)} disabled={!isEditable || disablePcs} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>HAWB :</span>
                                                <span>
                                                    <Form.Control type="text" name="hawb" value={formData.hawb}
                                                        onChange={(e) => handleInputChange('hawb', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Job no :</span>
                                                <span>
                                                    <Form.Control type="text" name="job_nr" value={formData.job_nr}
                                                        onChange={(e) => handleInputChange('job_nr', e.target.value)} readOnly />
                                                </span>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <span className="me-2">Bonded : </span>
                                                <Form.Check type="radio" label="YES" name="bonded" value="1"
                                                    checked={formData.bonded == "1"}
                                                    onChange={() => handleGeneralSettingChange('bonded', '1')} className="me-2" disabled={!isEditable} />
                                                <Form.Check type="radio" label="NO" name="bonded" value="0"
                                                    checked={formData.bonded == "0"}
                                                    onChange={() => handleGeneralSettingChange('bonded', '0')} disabled={!isEditable} />
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <span className="me-2">Health Inspection : </span>
                                                <Form.Check type="radio" label="YES" name="health_inspection" value="1"
                                                    id='hiy'
                                                    checked={formData.health_inspection == "1"}
                                                    onChange={() => handleGeneralSettingChange('health_inspection', '1')}
                                                    className="me-2" disabled={!isEditable} />
                                                <Form.Check type="radio" label="NO" name="health_inspection" value="0"
                                                    id='hin'
                                                    checked={formData.health_inspection == "0"}
                                                    onChange={() => handleGeneralSettingChange('health_inspection', '0')} disabled={!isEditable} />
                                            </li>

                                            <li>
                                                <span>Incoterm :</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" isDisabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Custom Code : </span>
                                                <span>
                                                    <Form.Control type="text" className='' name='shipper' value={formData?.custom_code || ''} onChange={(e) => handleInputChange('custom_code', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Origin Airport :</span>
                                                <span>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => { handleInputChange('origin', e.value); handleInputChange('station', e.value) }}
                                                        value={getDestination.find(opt => opt.value === formData?.flight_details[0]?.origin) || ''}
                                                        className="w-100" placeholder="Origin" isDisabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Custom Status :</span>
                                                <span>
                                                    <Select
                                                        options={customStatus}
                                                        onChange={(e) => handleInputChange('custom_status', e.value)}
                                                        value={customStatus.find(opt => opt.value === formData?.custom_status) || ''}
                                                        className="w-100" />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Screening Type : </span>
                                                <span>
                                                    <Form.Control type="text" className='' name='shipper' value={formData?.screening_type || ''} onChange={(e) => handleInputChange('screening_type', e.target.value)} />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Shipper :</span>
                                                <span>
                                                    <Form.Control type="text" name="shipper" value={formData.shipper}
                                                        onChange={(e) => handleInputChange('shipper', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Consignee :</span>
                                                <span>
                                                    <Form.Control type="text" name="consignee" value={formData.consignee}
                                                        onChange={(e) => handleInputChange('consignee', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li> */}

                                            <li>
                                                <span>Shipper :</span>
                                                {/* <span>
                                                <CreatableSelect
                                                options={shipperOptions} className="autoslct w-100" placeholder="Shipper" isDisabled={!isEditable} formatCreateLabel={(inputValue) => `+ Add "${inputValue}"`}
                                                value={
                                                    formData?.shipper_id 
                                                    ? shipperOptions.find(option => option.value === formData.shipper_id)
                                                    : formData?.shipper 
                                                    ? { label: formData.shipper, value: formData.shipper, __isNew__: true }
                                                    : null
                                                }
                                                onChange={(option) => {
                                                    if (!option) {
                                                    handleInputChange("shipper_id", null);
                                                    handleInputChange("shipper", null);
                                                    return;
                                                    }

                                                    if (option.__isNew__) {
                                                    handleInputChange("shipper", option.value);
                                                    handleInputChange("shipper_id", null);
                                                    } else {
                                                    handleInputChange("shipper_id", option.value);
                                                    handleInputChange("shipper", null);
                                                    }
                                                }}
                                                />
                                            </span> */}
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        // placeholder="Shipper City"
                                                        name="shipper"
                                                        value={formData?.shipper || ''}
                                                        onChange={(e) => handleInputChange('shipper', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipper City</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        // placeholder="Shipper City"
                                                        name="shipper_station"
                                                        value={formData?.shipper_station || ''}
                                                        onChange={(e) => handleInputChange('shipper_station', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipper Address</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        // placeholder="Shipper Address"
                                                        name="shipper_location"
                                                        value={formData?.shipper_location || ''}
                                                        onChange={(e) => handleInputChange('shipper_location', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Consignee :</span>
                                                {/* <span>
                                                <CreatableSelect
                                                options={consigneeOptions} placeholder="Consignee" className="autoslct w-100" isDisabled={!isEditable}
                                                formatCreateLabel={(inputValue) => `+ Add "${inputValue}"`}
                                                value={
                                                    formData?.consignee_id 
                                                    ? consigneeOptions.find(option => option.value === formData.consignee_id)
                                                    : formData?.consignee 
                                                    ? { label: formData.consignee, value: formData.consignee, __isNew__: true }
                                                    : null
                                                }
                                                onChange={(option) => {
                                                    if (!option) {
                                                    handleInputChange("consignee_id", null);
                                                    handleInputChange("consignee", null);
                                                    return;
                                                    }

                                                    if (option.__isNew__) {
                                                    handleInputChange("consignee", option.value);
                                                    handleInputChange("consignee_id", null);
                                                    } else {
                                                    handleInputChange("consignee_id", option.value);
                                                    handleInputChange("consignee", null);
                                                    }
                                                }}
                                                />
                                            </span> */}
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        // placeholder="Shipper City"
                                                        name="consignee"
                                                        value={formData?.consignee || ''}
                                                        onChange={(e) => handleInputChange('consignee', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li><span>Consignee City:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        name="consignee_station"
                                                        value={formData?.consignee_station || ''}
                                                        onChange={(e) => handleInputChange('consignee_station', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span></li>
                                            <li><span>Consignee Address:</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        className="w-50"
                                                        name="consignee_location"
                                                        value={formData?.consignee_location || ''}
                                                        onChange={(e) => handleInputChange('consignee_location', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Reference :</span>
                                                <span>
                                                    <Form.Control type="text" name="reference" value={formData.reference}
                                                        onChange={(e) => handleInputChange('reference', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Shipment Type :</span>
                                                <span>
                                                    <Select
                                                        options={TransportShipmentType}
                                                        name="shipment_type"
                                                        className="autoslct"
                                                        value={TransportShipmentType.find(opt => opt.value === formData.shipment_type) || ''}
                                                        onChange={(e) => handleInputChange('shipment_type', e.value)} isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Customer:</span>
                                                {/* <span>
                                                    <Select
                                                        options={customerOptions}
                                                        onChange={(e) => handleInputChange('customer_id', e.value)}
                                                        value={customerOptions.find(opt => opt.value === formData.customer_id) || ''}
                                                        className="w-100"
                                                        placeholder="--"
                                                    />
                                                </span> */}
                                                <span className='d-inline-flex'>
                                                    <Form.Control type="text" name="customer" className='flex-shrink-1' value={formData.customer_name} disabled />
                                                    <Button className='flex-grow-1 ms-2 customer_icon' onClick={contactModalOpen} disabled={!isEditable}><FontAwesomeIcon icon={faUser} /></Button>
                                                </span>
                                            </li>
                                            <li>
                                                <span></span>

                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>

                                    {/* Transport Section */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Package Information</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Gross Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="gross_weight" value={formData.gross_weight} className='ms-0'
                                                        onChange={(e) => handleInputChange('gross_weight', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Chargeable Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="chargeable_weight" value={formData.chargeable_weight}
                                                        onChange={(e) => handleInputChange('chargeable_weight', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Volume :</span>
                                                <span>
                                                    <Form.Control type="number" name="volume" value={formData.volume}
                                                        onChange={(e) => handleInputChange('volume', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Packaging :</span>
                                                <span>
                                                    <Select
                                                        options={getPackaging}
                                                        onChange={(e) => handleInputChange('packaging', e.value)}
                                                        value={getPackaging.find(opt => opt.value == formData.packaging) || ''}
                                                        className="w-100"
                                                        placeholder="--"
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Temperature :</span>
                                                <div className='d-inline-flex w-75'>
                                                    <Form.Control
                                                        type="number"
                                                        name="temparature"
                                                        value={formData.temparature}
                                                        onChange={(e) => handleInputChange('temparature', e.target.value)}
                                                        disabled={!isEditable || disabled}
                                                        // disabled
                                                        className='me-2'
                                                    />
                                                    <Select
                                                        options={TemperatureOptions}
                                                        onChange={(e) => handleInputChange('temperature_type', e.value)}
                                                        value={TemperatureOptions.find(opt => opt.value === formData.temperature_type) || ''}
                                                        className="w-100 temparate_slt" placeholder="--"
                                                        isDisabled={!isEditable || disabled}
                                                    // isDisabled
                                                    />
                                                </div>
                                            </li>
                                            {/* 
                                            <li>
                                                <span>Expected Pcs : <span className="text-danger">*</span></span>
                                                <span>
                                                    <Form.Control type="number" name="e_pcs" value={formData.e_pcs}
                                                        onChange={(e) => handleInputChange('e_pcs', e.target.value)} />
                                                </span>
                                            </li> */}

                                            {/* <li>
                                                <span>Expected Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="e_weight" value={formData.e_weight}
                                                        onChange={(e) => handleInputChange('e_weight', e.target.value)} disabled={!isEditable || !disablePcs} />
                                                </span>
                                            </li> */}
                                        </ul>
                                    </div>

                                    {/* Warehouse In Section */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Acceptance - Release</h4>

                                        </div>
                                        <ul>
                                            {formData?.is_in_stock == 0 && shId && <div className="text-end"><Link to="#" className="click_update" onClick={() => handleLinkClick('expected')}>Acceptance</Link></div>}
                                            <li>
                                                <span>Warehouse In :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_in"
                                                        value={formData.warehouse_in}
                                                        onChange={(e) => handleInputChange('warehouse_in', e.target.value)}
                                                        // disabled={!shId}
                                                        disabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Doc Type : </span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="warehouse_in_doc_type"
                                                        className="autoslct"
                                                        value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === formData.warehouse_in_doc_type) || ''}
                                                        onChange={(e) => handleInputChange('warehouse_in_doc_type', e.target.value)}
                                                        // isDisabled={!shId}
                                                        isDisabled
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC No :</span>
                                                <span>
                                                    <Form.Control type="text" name="warehouse_in_doc_no" value={formData.warehouse_in_doc_no}
                                                        onChange={(e) => handleInputChange('warehouse_in_doc_no', e.target.value)} disabled />
                                                </span>
                                            </li>

                                            <p className='text-end mb-0'>{shId && <Link to='#' onClick={() => { handleLinkClick('details', 'first') }}>Details</Link>}</p>
                                            <hr />

                                            <div>
                                                {formData?.is_in_release == 0 && shId && <div className='text-end'> <Link to='#' className="click_update" onClick={() => { handleLinkClick('instock') }}>Release</Link></div>}
                                                {/* {formData?.is_in_deliver == 0 && shId && <div className='text-end'> <Link to='#' className="click_update" onClick={() => { handleLinkClick('deliver') }}>Deliver</Link></div> } */}
                                                <li>
                                                    <span>Warehouse Out :</span>
                                                    <span>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="warehouse_out"
                                                            value={formData.warehouse_out}
                                                            onChange={(e) => handleInputChange('warehouse_out', e.target.value)}
                                                            // disabled={!shId}
                                                            disabled
                                                        />
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Doc Type : </span>
                                                    <span>
                                                        <Select
                                                            options={acceptanceWarehouseInhandlerOptions}
                                                            name="warehouse_out_doc_type"
                                                            className="autoslct"
                                                            value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === formData.warehouse_out_doc_type) || ''}
                                                            onChange={(e) => handleInputChange('warehouse_out_doc_type', e.target.value)}
                                                            // isDisabled={!shId}
                                                            isDisabled
                                                        />
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>DOC No :</span>
                                                    <span>
                                                        <Form.Control type="text" name="warehouse_out_doc_no" value={formData.warehouse_out_doc_no}
                                                            onChange={(e) => handleInputChange('warehouse_out_doc_no', e.target.value)} disabled />
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Receiving Party :</span>
                                                    <span>
                                                        {/* <Form.Control type="text" name="receiving_party" value={formData.receiving_party} disabled={true}
                                                            onChange={(e) => handleInputChange('receiving_party', e.target.value)} disabled /> */}
                                                        <Select
                                                            options={companyOption}
                                                            name="receiving_party"
                                                            className="autoslct"
                                                            value={
                                                                companyOption.find(
                                                                    opt => opt.value === formData.receiving_party
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                handleInputChange(
                                                                    'receiving_party',
                                                                    selectedOption?.value || ''
                                                                )
                                                            }
                                                            isDisabled
                                                        />
                                                    </span>
                                                </li>
                                                <p className='text-end'>{shId && <Link to='#' onClick={() => { handleLinkClick('details', "second") }}>Details</Link>}</p>
                                            </div>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details mb-2'>
                                        <div className='ship_head'>
                                            <h4>Flight Details</h4>
                                        </div>
                                        {formData?.flight_details?.map((data, index) => (
                                            <div key={data.id} className="flight_section mb-3">
                                                <div className="flex_gap">
                                                    <h4>Flight {index + 1}</h4>
                                                    {formData.flight_details.length > 1 && (
                                                        <img
                                                            src={Trash}
                                                            alt=""
                                                            className="imag_trash"
                                                            onClick={() => removeFlight(data.id)}
                                                        />
                                                    )}
                                                </div>
                                                <div className="mb-2">
                                                    <Form.Label>Airline Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={data.airline_name}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="flex_gap mb-2">
                                                    <div className="w-50">
                                                        <Form.Label>Flight Number</Form.Label>
                                                        <div className="flex_gap">
                                                            <Select
                                                                options={getOwnerCodes}
                                                                onChange={(e) =>
                                                                    handleFlChange(data.id, "flight_code", e.value)
                                                                }
                                                                value={
                                                                    getOwnerCodes.find(
                                                                        (option) => option.value === data.flight_code
                                                                    ) || null
                                                                }
                                                                isDisabled={!isEditable}
                                                                className="autoslct"
                                                            />
                                                            <Form.Control
                                                                type="text"
                                                                value={data.flight_number}
                                                                onChange={(e) =>
                                                                    handleFlChange(data.id, "flight_number", e.target.value)
                                                                }
                                                                disabled={!isEditable}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="w-50">
                                                        <Form.Label>Flight Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            value={data.flight_date}
                                                            onChange={(e) =>
                                                                handleFlChange(data.id, "flight_date", e.target.value)
                                                            }
                                                            disabled={!isEditable}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex_gap mb-2">
                                                    <div className="w-50">
                                                        <Form.Label>Origin</Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) =>
                                                                handleFlChange(data.id, "origin", e.value)
                                                            }
                                                            value={
                                                                getDestination.find(
                                                                    (option) => option.value === data.origin
                                                                ) || null
                                                            }
                                                            isDisabled={!isEditable}
                                                            className="autoslct w-100"
                                                        />
                                                    </div>

                                                    <div className="w-50">
                                                        <Form.Label>Destination</Form.Label>
                                                        <Select
                                                            options={getDestination}
                                                            onChange={(e) =>
                                                                handleFlChange(data.id, "destination", e.value)
                                                            }
                                                            value={
                                                                getDestination.find(
                                                                    (option) => option.value === data.destination
                                                                ) || null
                                                            }
                                                            isDisabled={!isEditable}
                                                            className="autoslct w-100"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex_gap mb-2">
                                                    <div className="w-50">
                                                        <Form.Label>ETA</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            value={data.eta}
                                                            onChange={(e) =>
                                                                handleFlChange(data.id, "eta", e.target.value)
                                                            }
                                                            disabled={!isEditable}

                                                        />
                                                    </div>

                                                    <div className="w-50">
                                                        <Form.Label>ATA</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            value={data.ata}
                                                            onChange={(e) =>
                                                                handleFlChange(data.id, "ata", e.target.value)
                                                            }
                                                            disabled={!isEditable}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="text-end mt-2">
                                                    <Button variant="primary" onClick={addFlight} disabled={!isEditable}>
                                                        + Add Flight
                                                    </Button>
                                                </div>

                                            </div>
                                        ))}

                                    </div>
                                    <div className='flbg details'>
                                        <div className='ship_head'>
                                            <h4>Transport</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Transport Type :</span>
                                                <span>
                                                    <Select
                                                        options={TransportOptions}
                                                        onChange={(e) => handleInputChange('transport_type', e.value)}
                                                        value={TransportOptions.find(opt => opt.value === formData.transport_type) || ''}
                                                        isDisabled={!isEditable}
                                                        className="w-100" />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handler name :</span>
                                                <span>
                                                    <Select
                                                        options={getHandler}
                                                        name="t_handler_org_id"
                                                        className="autoslct"
                                                        value={getHandler.find(opt => opt.value === formData.t_handler_org_id) || null}
                                                        onChange={(selectedOption) =>
                                                            handleInputChange('t_handler_org_id', selectedOption ? selectedOption.value : '')
                                                        }
                                                        isDisabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Delivery date: </span>
                                                <span>
                                                    <Form.Control
                                                        type="date" name="delivery_date" value={formData.delivery_date}
                                                        onChange={(e) => handleInputChange('delivery_date', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Delivery time: </span>
                                                <span>
                                                    <Form.Control
                                                        type="time" name="delivery_time" value={formData.delivery_time}
                                                        onChange={(e) => handleInputChange('delivery_time', e.target.value)}
                                                        disabled={!isEditable}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                                <span>Shipment Type :</span>
                                                <span>
                                                    <Select
                                                        options={TransportShipmentType}
                                                        name="shipment_type"
                                                        className="autoslct"
                                                        value={TransportShipmentType.find(opt => opt.value === formData.shipment_type) || ''}
                                                        onChange={(e) => handleInputChange('shipment_type', e.value)}
                                                    />
                                                </span>
                                            </li> */}
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Checks</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                        </div>
                                        <ul className='checks'>
                                            <li>
                                                <span>ETA :</span>
                                                <span>
                                                    <Form.Control type="datetime-local" name='eta' value={formData.eta}
                                                        onChange={(e) => handleInputChange('eta', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>ATA :</span>
                                                <span>
                                                    <Form.Control type="datetime-local" name='ata' value={formData.ata}
                                                        onChange={(e) => handleInputChange('ata', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>NOA :</span>
                                                <span>
                                                    <Form.Control type="datetime-local" name='noa' value={formData.noa}
                                                        onChange={(e) => handleInputChange('noa', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Pickup Airline :</span>
                                                <span>
                                                    <Form.Control type="datetime-local" name='pickup_airline' value={formData.pickup_airline}
                                                        onChange={(e) => handleInputChange('pickup_airline', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Inbound WHS :</span>
                                                <span className='d-flex'>
                                                    <Form.Control type="text" name='inbound_whs' value={formData.inbound_whs}
                                                        onChange={(e) => handleInputChange('inbound_whs', e.target.value)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>CI / PL :</span>
                                                <span className='d-flex'>
                                                    <Form.Check type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === 1}
                                                        id='ci_pl-1' onChange={(e) => handleInputChange('ci_pl', 1)} disabled={!isEditable} />
                                                    <Form.Check type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='ci_pl-2' onChange={(e) => handleInputChange('ci_pl', '0')} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>HS Code :</span>
                                                <span className='d-flex'>
                                                    <Form.Check type="radio" label="Yes" name="hs_code" value="true" checked={formData.hs_code === 1}
                                                        id='hsc-1' onChange={(e) => handleInputChange('hs_code', 1)} disabled={!isEditable} />
                                                    <Form.Check type="radio" label="No" name="hs_code" value="false" checked={formData.hs_code === 0}
                                                        id='hsc-2' onChange={(e) => handleInputChange('hs_code', 0)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>ATR / REX :</span>
                                                <span className='d-flex'>
                                                    <Form.Check type="radio" label="Yes" name="atr_rex" value="true" checked={formData.atr_rex === 1}
                                                        id='atr-1' onChange={(e) => handleInputChange('atr_rex', 1)} disabled={!isEditable} />
                                                    <Form.Check type="radio" label="No" name="atr_rex" value="false" checked={formData.atr_rex === 0}
                                                        id='atr-2' onChange={(e) => handleInputChange('atr_rex', 0)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>ATR received :</span>
                                                <span className='d-flex'>
                                                    <Form.Check type="radio" label="Yes" name="atr_received" value="true" checked={formData.atr_received === 1}
                                                        id='atrr-1' onChange={(e) => handleInputChange('atr_received', 1)} disabled={!isEditable} />
                                                    <Form.Check type="radio" label="No" name="atr_received" value="false" checked={formData.atr_received === 0}
                                                        id='atrr-2' onChange={(e) => handleInputChange('atr_received', 0)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Quote Required :</span>
                                                <span className='d-flex'>
                                                    <Form.Check type="radio" label="Yes" name="quote_received" value="true" checked={formData.quote_received === 1}
                                                        id='qr-1' onChange={(e) => handleInputChange('quote_received', 1)} disabled={!isEditable} />
                                                    <Form.Check type="radio" label="No" name="quote_received" value="false" checked={formData.quote_received === 0}
                                                        id='qr-2' onChange={(e) => handleInputChange('quote_received', 0)} disabled={!isEditable} />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        }
                        {selectedButton === 'attachment' &&
                            <div className='flbg'>
                                <div className='all_file mb-3'>
                                    <h4>All files</h4>
                                    <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(e) => handleFileChange(e, 'A')}
                                        multiple
                                    />
                                </div>
                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                                    <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.map((data, index) => {
                                                    const fileName = data.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();

                                                    return (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td><div className='file_attch'>
                                                                {["jpeg", "jpg", "png", "webp"].includes(data.file_path?.split(".")[data.file_path?.split(".").length - 1]
                                                                ) ? (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span> */}
                                                                        {/*data.file_name*/}
                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                        {/* </span> */}

                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <FontAwesomeIcon icon={faFileLines} />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span className="d-flex rafilename">
                                                                            <img src={Docmnt} className="fileimg" />
                                                                            <span>{data.file_name}</span>
                                                                        </span> */}
                                                                    </>
                                                                )}
                                                            </div>
                                                                {/* <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div> */}
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic" disabled={data.remarks_attachment === 1}>
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["pdf"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => {
                                                        const fileName = data.file_name;
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();

                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <Form.Check // prettier-ignore
                                                                        type="checkbox"
                                                                        id="checkbox"
                                                                    // checked={selectedRows.some(
                                                                    //     (row) => row.attachment_id === file.id
                                                                    // )}
                                                                    // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                    />
                                                                </td>
                                                                <td className="delimg">
                                                                    <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                </td>
                                                                <td>
                                                                    <div className='file_attch'>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span> */}
                                                                        {/*data.file_name*/}
                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                        {/* </span> */}
                                                                    </div>
                                                                    {/* <div className='file_attch'>
                                                                        <div className='file_icon'>
                                                                            <FontAwesomeIcon icon={faFileLines} />
                                    </div>
                                                                        <div className='file_text'>
                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                        </div>
                                                                    </div> */}
                                                                </td>
                                                                <td><p>{data.category[0]}</p></td>
                                                                <td>
                                                                    <p>{data.modified_name}</p>
                                                                    <span>{data.modified_email}</span>
                                                                </td>
                                                                <td>
                                                                    <span>{data.last_modified}</span>
                                                                </td>
                                                                <td>
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                            <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                </Tabs>
                            </div>
                        }
                        {selectedButton === 'remarks' &&
                            <div className='chat_bg'>
                                <div className='flbg right_side record_remarks'>
                                    <div className='chat_box'>
                                        {formData?.remarks?.map((msg, index) => (
                                            <>
                                                <Accordion defaultActiveKey={index.toString()}>
                                                    <Accordion.Item eventKey={index.toString()}>
                                                        <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')} className=''>
                                                            <div className='position-relative'><img src={Pack} /> {msg.created_by}</div>
                                                            <div className='acorright'> {msg.attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />} <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                        <Accordion.Body>
                                                            {msg.message}
                                                            {msg.attachments?.length > 0 &&
                                                                <div className='d-flex mt-1 '>
                                                                    {msg.attachments?.map((file, index) => {
                                                                        const fileName = file?.file_name;
                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                        const extension = fileName?.split(".").pop();
                                                                        return (
                                                                            <>
                                                                                <div key={`ns_${index}`} className="mag_image">
                                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                    ) ? (
                                                                                        <>
                                                                                            <img
                                                                                                src={file.file_path}
                                                                                                alt="Preview"
                                                                                                className=''
                                                                                                style={{
                                                                                                    maxWidth: "30px",
                                                                                                    maxHeight: "30px",
                                                                                                    marginRight: "5px",
                                                                                                }}
                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                            // onClick={() =>
                                                                                            //     handleFileClick(file.file_path)
                                                                                            // }
                                                                                            />
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <span className="d-flex rafilename">
                                                                                                <img src={Docmnt} className="fileimg" />
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                    <span className="rafilename">
                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                    </span>
                                                                                    <button
                                                                                        className="msg_download"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            handleDownload(file.file_path, file.file_name)
                                                                                        }
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                            }
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </>
                                        ))}
                                    </div>
                                    <div>
                                        <Form.Group className='massge_text'>
                                            <div className='mag_send'>
                                                <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                <Button variant="primary" onClick={() => handleSubmit('R')} ><FontAwesomeIcon icon={faPaperPlane} /></Button>
                                                {/* <button className='btn btn-primary drpbtn'>Browse Files</button> */}
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileChange(e, 'R')}
                                                    multiple
                                                />
                                            </div>
                                            <div className='d-flex reco_image'>
                                                {rfiles.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <div key={index} className='img-thumbnail'>
                                                            {file?.type?.startsWith('image/') ? (
                                                                <img
                                                                    // src={URL.createObjectURL(file)}
                                                                    src={file.base64}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                />
                                                            ) : (
                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                            )}
                                                            <span className="rafilename">
                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                            </span>
                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index, 'R')}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder='Enter a description...'
                                                    rows={2}
                                                    name='message'
                                                    onChange={conversationChange}
                                                    value={sendData?.message || ''}
                                                // disabled={isSwitchOn === true}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </div>

            {/* <div className="text-center mt-3 mb-3">
                <button type="button" className="stk_cancel btn btn-light" onClick={() => window.location.href = '/ForwarderShipments/ShipmentRecords'}>CANCEL</button>
                <button type="button" className="stk_save posr btn btn-primary" onClick={() => handleSubmit('S')} >{shId ? 'UPDATE' : 'Submit'}</button>
            </div> */}

            <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
                    <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
                    {modalSection === 'S' &&
                        <Form.Group className="me-2">
                            <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                                <option value="0">Select</option>
                                <option value="Invoice">Invoice</option>
                                <option value="Packinglist">Packinglist</option>
                                <option value="Emails">Emails</option>
                                <option value="HAWB">HAWB</option>
                                <option value="MAWB">MAWB</option>
                                <option value="Manifest">Manifest</option>
                                <option value="Customs">Customs</option>
                                <option value="Proposal">Proposal</option>
                                <option value="Other">Other</option>
                            </Form.Select>
                        </Form.Group>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        {modalSection === 'S' ?
                            <Button variant="primary" onClick={modalUpdate}>
                                Update
                            </Button>
                            :
                            <>
                                <Button variant="secondary" onClick={() => setTypeModal(false)}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={modalUpdate}>
                                    Yes
                                </Button>
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <div className='modal-title h4'>Upload Attachments</div>
                    <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div className='dropfile' onDrop={handleDrop} onDragOver={handleDragOver}>
                                <img src={Shipupload} alt="upload" />
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, uploadTarget) : handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 25 MB</span>
                                <input
                                    type="file"
                                    ref={(el) => {
                                        if (uploadTarget) {
                                            fileInputRefs.current[uploadTarget] = el;
                                        }
                                    }}
                                    style={{ display: 'none' }}
                                    onChange={uploadTarget ? (e) => handleFileChange(e, 'C', uploadTarget) : (e) => handleFileChange(e, 'A')}
                                    multiple
                                />
                            </div>
                            <div className='attach_shipment'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <>
                                                <img
                                                    src={file.base64}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                                <span>{file.file_name}</span>
                                            </>
                                        ) : (
                                            <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={showHealthModal} onHide={() => setShowHealthModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Redirect to VWA?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to fill VWA details now?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={cancelHealthModal}>No</Button>
                        <Button variant="primary" onClick={confirmHealthModal}>Yes</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={vwafilled} onHide={() => setVwaFilled(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <Modal.Title>VWA not filled completely</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Your VWA is not filled completely, do you still want to submit?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => { setVwaFilled(false); setSubmitSection('') }}>No</Button>
                        <Button variant="primary" onClick={() => handleConfirmSubmit('S')}>Yes</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={addLocationModal} onHide={hideLocationModal} className='addfrom add_category_modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Station<span className='text-danger'>*</span></Form.Label>
                            <Select
                                options={getDestination}
                                onChange={(e) => handleLocationChange('station', e.value)}
                                placeholder="Station"
                                className="w-100"
                                name="station"
                                value={getDestination.find(option => option.value === locationData?.station) || ''}
                            />
                        </Col>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Location Name<span className='text-danger'>*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter Location" value={locationData.location} onChange={(e) => handleLocationChange('location', e.target.value)} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={hideLocationModal}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleLocationSave}>Save</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={locationModal} onHide={() => setLocationModal(false)} className='addfrom add_category_modal' centered size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className='text-end mt-2 fwr_customer_add'><Button variant="primary" onClick={handleAddLocation} >+ Add Location</Button></span>
                    <div className='trashdonload add_category_modal_bdy_content mt-0'>
                        {!isLoadingl && <div ref={lgridRef} className='bookinggrid' ></div>}
                    </div>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setLocationModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleLocationApply}>Apply</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={acceptanceModal} onHide={() => setAcceptanceModal(false)} className="addfrom add_category_modal" centered size="">
                <Modal.Header closeButton>
                    <Modal.Title>Move In Stock - Acceptance</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='modal_from'>
                        <h5>MAWB: {formData.master_airwaybill}</h5>
                        <Accordion defaultActiveKey="0" flush>
                            <Accordion.Item eventKey="0" key="0">
                                <Accordion.Header>HAWB: {acceptanceFormData.hawb}</Accordion.Header>
                                <Accordion.Body>

                                    <Form.Group as={Row} className="mb-2">
                                        <Col sm='6'>
                                            <Form.Label>Expected Pieces<span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={acceptanceFormData.e_pcs}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm='6'>
                                            <Form.Label>Expected Weight<span></span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={acceptanceFormData.e_weight}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label column sm="12">Pieces confirm? <span className="text-danger">*</span></Form.Label>
                                        <Col sm="12">
                                            <Form.Check
                                                type="radio"
                                                label="YES"
                                                name="piecesConfirm"
                                                id="piecesConfirmYes"
                                                value="YES"
                                                checked={acceptanceFormData.piecesConfirm === 'YES'}
                                                onChange={e => {
                                                    handleAcceptanceFormChange('piecesConfirm', e.target.value);
                                                    if (e.target.value === 'YES') {
                                                        handleAcceptanceFormChange('a_pcs', acceptanceFormData.e_pcs);
                                                        handleAcceptanceFormChange('a_weight', acceptanceFormData.e_weight);
                                                    }
                                                }}
                                                inline
                                            />
                                            <Form.Check
                                                type="radio"
                                                label="NO"
                                                name="piecesConfirm"
                                                id="piecesConfirmNo"
                                                value="NO"
                                                checked={acceptanceFormData.piecesConfirm === 'NO'}
                                                onChange={e => {
                                                    handleAcceptanceFormChange('piecesConfirm', e.target.value);
                                                    handleAcceptanceFormChange('a_pcs', '');
                                                    handleAcceptanceFormChange('a_weight', '');
                                                }}
                                                inline
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-2">
                                        <Col sm='6'>
                                            <Form.Label>Accepted Pieces<span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                max={acceptanceFormData.e_pcs}
                                                value={acceptanceFormData.a_pcs}
                                                onChange={e => handleAcceptanceFormChange('a_pcs', e.target.value)}
                                                disabled={acceptanceFormData.piecesConfirm === 'YES'}
                                            />
                                        </Col>
                                        <Col sm='6'>
                                            <Form.Label>Accepted Weight<span></span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={acceptanceFormData.a_weight}
                                                onChange={e => handleAcceptanceFormChange('a_weight', e.target.value)}
                                                disabled={acceptanceFormData.piecesConfirm === 'YES'}
                                            />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Col sm='6'>
                                            <Form.Label>Location<span></span></Form.Label>
                                            {isLoadingLocation ? (
                                                <div>Loading locations...</div>
                                            ) : (
                                                <Select
                                                    options={locationOptions || []}
                                                    onChange={(selected) => {
                                                        handleAcceptanceFormChange("location", selected ? selected.value : "");
                                                    }}
                                                    placeholder="Location"
                                                    className="rfs_autoslct"
                                                    name="location"
                                                    value={
                                                        locationOptions && locationOptions.find(
                                                            (option) => option.value === acceptanceFormData.location
                                                        ) || null
                                                    }
                                                />
                                            )}
                                        </Col>
                                        <Col sm="3" className='pe-0'>
                                            <Form.Label>Temperature<span><span className="text-danger">*</span></span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={acceptanceFormData.temparature}
                                                onChange={e => handleAcceptanceFormChange("temparature", e.target.value)}
                                            />
                                        </Col>
                                        <Col sm="3">
                                            <Form.Label>Temp Type<span><span className="text-danger">*</span></span></Form.Label>
                                            <Select
                                                options={TemperatureOptions}
                                                onChange={(e) => handleAcceptanceFormChange("temperature_type", e.value)}
                                                value={TemperatureOptions.find(opt => opt.value === acceptanceFormData.temperature_type) || ''}
                                                className="w-100"
                                            />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Col sm='12'>
                                            <Form.Label>Warehouse In : <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                value={acceptanceFormData.warehouse_in}
                                                onChange={e => handleAcceptanceFormChange('warehouse_in', e.target.value)}
                                            />
                                        </Col>
                                    </Form.Group>

                                    {acceptanceFormData.warehouse_in_doc_type === 'Transfer' ? (
                                        <Form.Group as={Row} className="mb-2">
                                            <Col sm="12">
                                                <Form.Label>Doc Type : <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={acceptanceWarehouseInhandlerOptions}
                                                    name="warehouse_in_doc_type"
                                                    className="w-100 autoslct"
                                                    value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === acceptanceFormData.warehouse_in_doc_type) || ''}
                                                    onChange={(e) => handleAcceptanceFormChange('warehouse_in_doc_type', e.value)}
                                                />
                                            </Col>
                                        </Form.Group>
                                    ) : (
                                        <Form.Group as={Row} className="mb-2">
                                            <Col sm='6'>
                                                <Form.Label>Doc Type : <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={acceptanceWarehouseInhandlerOptions}
                                                    name="warehouse_in_doc_type"
                                                    className="w-100 autoslct"
                                                    value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === acceptanceFormData.warehouse_in_doc_type) || ''}
                                                    onChange={(e) => handleAcceptanceFormChange('warehouse_in_doc_type', e.value)}
                                                />
                                            </Col>
                                            <Col sm='6'>
                                                <Form.Label>DOC No : <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={acceptanceFormData.warehouse_in_doc_no}
                                                    onChange={e => handleAcceptanceFormChange('warehouse_in_doc_no', e.target.value)}
                                                />
                                            </Col>
                                        </Form.Group>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setAcceptanceModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleCheckSubmit}>Submit</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={releaseModal} onHide={() => setReleaseModal(false)} className="addfrom add_category_modal" centered size="">
                <Modal.Header closeButton>
                    <Modal.Title>Release</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_from">
                        <div className="saairbill mb-2">
                            <div>
                                <Form.Label>Customer Info</Form.Label>
                            </div>
                            <Select
                                options={companyOption}
                                placeholder="Condition Code"
                                className="down_selct"
                                onChange={(selected) => {
                                    setReleaseData(prev => ({
                                        ...prev,
                                        company_name: selected?.label,
                                        trucking_Id: selected?.value,
                                    }));
                                }}
                                name="status"
                                value={companyOption?.find(value => value.value === releaseData?.trucking_Id)}
                            />
                        </div>
                        <h5>MAWB: {formData.master_airwaybill}</h5>
                        <Accordion defaultActiveKey="0" flush>
                            {releaseData?.hawb_details?.map((group, idx) => (
                                <Accordion.Item eventKey={idx.toString()} key={idx}>
                                    <Accordion.Header>HAWB {group.hawb}</Accordion.Header>
                                    <Accordion.Body>
                                        <ul className="relase_pic">
                                            <li>
                                                <span>No Labels :</span>
                                                <span>Pick Status : {formData?.cargo_acceptance_det_details?.pick_status}</span>
                                            </li>
                                            <li>
                                                <span>Label :</span>
                                                <span>Location :{formData?.location}</span>
                                            </li>
                                            <li>
                                                <span>InStock Pieces :  {formData?.cargo_acceptance_det_details?.actual_hawb_pieces}</span>
                                                <span>Picked List : <a href={formData?.cargo_acceptance_det_details?.picklist}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    <img src={Rapdf} alt="PDF" style={{ width: "25px" }} />
                                                </a></span>
                                            </li>
                                            <li>
                                                <span>Release Pieces : {formData?.released_pcs}</span>
                                            </li>
                                        </ul>

                                        {group.is_deliver == "0" && (
                                            <>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="12">
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="6">
                                                                <Form.Label>ID Type</Form.Label>
                                                                <Select
                                                                    options={IdTypeOption}
                                                                    value={IdTypeOption.find(opt => opt.value === group.release_id_type) || null}
                                                                    onChange={(selected) => { handleReleaseGroupChange(idx, "release_id_type", selected.value); }}
                                                                    className="w-100"
                                                                />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>ID Number:</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={group.release_id_number}
                                                                    onChange={(e) => handleReleaseGroupChange(idx, "release_id_number", e.target.value)}
                                                                /></Col>
                                                        </Form.Group>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="12">
                                                        <Form.Group as={Row} className="mb-2">
                                                            {/* Left column with input */}
                                                            <Col sm="6">
                                                                <Form.Label>Pieces to be picked</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    max={(formData?.cargo_acceptance_det_details?.actual_hawb_pieces || 0) - (group?.released_pcs || 0)}
                                                                    min="0"
                                                                    value={group.to_be_picked_pcs}
                                                                    onChange={(e) => handleReleaseGroupChange(idx, "to_be_picked_pcs", e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Release To</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="release_to"
                                                                    value={group.release_to || ""}
                                                                    onChange={(e) => handleReleaseGroupChange(idx, "release_to", e.target.value)}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </Col>
                                                </Form.Group>
                                            </>
                                        )}
                                        <Form.Group as={Row} className="mb-2">
                                            <Form.Label column sm="12">
                                                Delivered to Consignee?
                                            </Form.Label>
                                            <Col sm="12">
                                                <Form.Check
                                                    type="radio"
                                                    label="YES"
                                                    name={`is_deliver-${idx}`}
                                                    id={`isDeliverYes-${idx}`}
                                                    value="1"
                                                    checked={group.is_deliver == "1"}
                                                    onChange={(e) => handleReleaseGroupChange(idx, "is_deliver", e.target.value)}
                                                    inline
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="NO"
                                                    name={`is_deliver-${idx}`}
                                                    id={`isDeliverNo-${idx}`}
                                                    value="0"
                                                    checked={group.is_deliver == "0"}
                                                    onChange={(e) => handleReleaseGroupChange(idx, "is_deliver", e.target.value)}
                                                    inline
                                                />
                                            </Col>
                                        </Form.Group>

                                        {group.is_deliver == "1" && (
                                            <>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label>Picked Pieces <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={group.picked_pcs}
                                                            onChange={(e) => handleReleaseGroupChange(idx, "picked_pcs", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label>Delivery Pieces <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={group.delivered_pcs}
                                                            onChange={(e) => handleReleaseGroupChange(idx, "delivered_pcs", e.target.value)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label> Release By <span>*</span> </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            value={group.name || ""}
                                                            onChange={(e) => handleReleaseGroupChange(idx, "name", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label> Warehouse Out <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            value={group.warehouse_out}
                                                            onChange={(e) => handleReleaseGroupChange(idx, "warehouse_out", e.target.value)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                {group.warehouse_out_doc_type === 'Transfer' ? (
                                                    <Form.Group as={Row} className="mb-2">
                                                        <Col sm="12">
                                                            <Form.Label>
                                                                Doc Type : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Select
                                                                options={acceptanceWarehouseInhandlerOptions}
                                                                name="warehouse_out_doc_type"
                                                                className="w-100 autoslct"
                                                                value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === group.warehouse_out_doc_type) || ''}
                                                                onChange={e => handleReleaseGroupChange(idx, 'warehouse_out_doc_type', e.value)}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                ) : (
                                                    <Form.Group as={Row} className="mb-2">
                                                        <Col sm="6">
                                                            <Form.Label>
                                                                Doc Type : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Select
                                                                options={acceptanceWarehouseInhandlerOptions}
                                                                name="warehouse_out_doc_type"
                                                                className="w-100 autoslct"
                                                                value={acceptanceWarehouseInhandlerOptions.find(opt => opt.value === group.warehouse_out_doc_type) || ''}
                                                                onChange={e => handleReleaseGroupChange(idx, 'warehouse_out_doc_type', e.value)}
                                                            />
                                                        </Col>
                                                        <Col sm="6">
                                                            <Form.Label>
                                                                DOC No : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={group.warehouse_out_doc_no}
                                                                onChange={e => handleReleaseGroupChange(idx, 'warehouse_out_doc_no', e.target.value)}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                )}
                                            </>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setReleaseModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleReleaseSubmit}>Submit</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={deliverModal} onHide={() => setDeliverModal(false)} className="addfrom add_category_modal" centered size="">
                <Modal.Header closeButton>
                    <Modal.Title>Deliver</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_from">
                        <div className="saairbill mb-2">
                            <div>
                                <Form.Label>Customer Info</Form.Label>
                            </div>
                            <Select
                                options={companyOption}
                                placeholder="Condition Code"
                                className="down_selct"
                                onChange={(selected) => {
                                    setDeliverData(prev => ({
                                        ...prev,
                                        company_name: selected?.label,
                                        trucking_Id: selected?.value,
                                    }));
                                }}
                                name="status"
                                value={companyOption?.find(value => value.value === releaseData?.trucking_Id)}
                            />
                        </div>
                        <h5>MAWB: {formData.master_airwaybill}</h5>
                        <Accordion defaultActiveKey="0" flush>
                            {deliverData?.hawb_details?.map((group, idx) => (
                                <Accordion.Item eventKey={idx.toString()} key={idx}>
                                    <Accordion.Header>HAWB {group.hawb}</Accordion.Header>
                                    <Accordion.Body>
                                        <ul className="relase_pic">
                                            <li>
                                                <span>No Labels :</span>
                                                <span>Pick Status : {formData?.cargo_acceptance_det_details?.pick_status}</span>
                                            </li>
                                            <li>
                                                <span>Label :</span>
                                                <span>Location :{formData?.location}</span>
                                            </li>
                                            <li>
                                                <span>InStock Pieces :  {formData?.cargo_acceptance_det_details?.actual_hawb_pieces}</span>
                                                <span>Picked List : <a href={formData?.cargo_acceptance_det_details?.picklist}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    <img src={Rapdf} alt="PDF" style={{ width: "25px" }} />
                                                </a></span>
                                            </li>
                                            <li>
                                                <span>Release Pieces : {formData?.released_pcs}</span>
                                            </li>
                                        </ul>

                                        <Form.Group as={Row} className="mb-2">
                                            <Form.Label column sm="12">
                                                Delivered to Consignee?
                                            </Form.Label>
                                            <Col sm="12">
                                                <Form.Check
                                                    type="radio"
                                                    label="YES"
                                                    name={`is_deliver-${idx}`}
                                                    id={`isDeliverYes-${idx}`}
                                                    value="1"
                                                    checked={group.is_deliver == "1"}
                                                    onChange={(e) =>
                                                        handleDeliverGroupChange(
                                                            idx,
                                                            "is_deliver",
                                                            e.target.value
                                                        )
                                                    }
                                                    inline
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="NO"
                                                    name={`is_deliver-${idx}`}
                                                    id={`isDeliverNo-${idx}`}
                                                    value="0"
                                                    checked={group.is_deliver == "0"}
                                                    onChange={(e) =>
                                                        handleDeliverGroupChange(
                                                            idx,
                                                            "is_deliver",
                                                            e.target.value
                                                        )
                                                    }
                                                    inline
                                                    disabled

                                                />
                                            </Col>
                                        </Form.Group>

                                        {group.is_deliver == "1" && (
                                            <>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label>
                                                            Picked Pieces
                                                            <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={group.picked_pcs}
                                                            onChange={(e) => {
                                                                handleDeliverGroupChange(idx, "picked_pcs", e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label>
                                                            Delivery Pieces
                                                            <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            value={group.delivered_pcs}
                                                            onChange={(e) => {
                                                                handleDeliverGroupChange(idx, "delivered_pcs", e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label>
                                                            Release By <span>*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            value={group.name || ""}
                                                            onChange={(e) =>
                                                                handleDeliverGroupChange(idx, "name", e.target.value)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label>
                                                            Warehouse Out
                                                            <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            value={group.warehouse_out}
                                                            onChange={(e) =>
                                                                handleDeliverGroupChange(
                                                                    idx,
                                                                    "warehouse_out",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                {group.warehouse_out_doc_type === 'Transfer' ? (
                                                    <Form.Group as={Row} className="mb-2">
                                                        <Col sm="12">
                                                            <Form.Label>
                                                                Doc Type : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Select
                                                                options={acceptanceWarehouseInhandlerOptions}
                                                                name="warehouse_out_doc_type"
                                                                className="w-100 autoslct"
                                                                value={
                                                                    acceptanceWarehouseInhandlerOptions.find(
                                                                        opt => opt.value === group.warehouse_out_doc_type
                                                                    ) || ''
                                                                }
                                                                onChange={e =>
                                                                    handleDeliverGroupChange(idx, 'warehouse_out_doc_type', e.value)
                                                                }
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                ) : (
                                                    <Form.Group as={Row} className="mb-2">
                                                        <Col sm="6">
                                                            <Form.Label>
                                                                Doc Type : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Select
                                                                options={acceptanceWarehouseInhandlerOptions}
                                                                name="warehouse_out_doc_type"
                                                                className="w-100 autoslct"
                                                                value={
                                                                    acceptanceWarehouseInhandlerOptions.find(
                                                                        opt => opt.value === group.warehouse_out_doc_type
                                                                    ) || ''
                                                                }
                                                                onChange={e =>
                                                                    handleDeliverGroupChange(idx, 'warehouse_out_doc_type', e.value)
                                                                }
                                                            />
                                                        </Col>
                                                        <Col sm="6">
                                                            <Form.Label>
                                                                DOC No : <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={group.warehouse_out_doc_no}
                                                                onChange={e =>
                                                                    handleDeliverGroupChange(idx, 'warehouse_out_doc_no', e.target.value)
                                                                }
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                )}
                                            </>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setDeliverModal(false)}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={() => handleDeliverSubmit()}>Submit</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={detailsModal} onHide={() => setDetailsModal(false)} className="addfrom add_category_modal" centered size="">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {movementLog?.length > 0 && movementLog[0]?.stage === 'in_stock'
                            ? 'Warehouse In Details'
                            : 'Warehouse Out Details'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {movementLog?.length > 0 ? (<>
                        {movementLog[0]?.stage === 'in_stock' ? (
                            movementLog.map((item, index) => (
                                <div key={index} className="warehouse_list">
                                    <ul>
                                        <li>
                                            <p><span>Warehouse In At:</span> {item.warehouse_in_at || '-'}</p>
                                        </li>
                                        <li>
                                            <span>Doc Type: {item.warehouse_in_doc_type || '-'}</span>
                                            <span>Doc No: {item.warehouse_in_doc_number || '-'}</span>
                                        </li>
                                    </ul>
                                </div>
                            ))
                        ) : (
                            movementLog.map((item, index) => (
                                <div key={index} className="warehouse_list">

                                    <ul>
                                        <li>
                                            <p><span>Warehouse Out At:</span> {item.warehouse_out_at || '-'}</p>
                                        </li>
                                        <li>
                                            <span>Doc Type: {item.warehouse_out_doc_type || '-'}</span>
                                            <span>Doc No: {item.warehouse_out_doc_number || '-'}</span>
                                        </li>
                                    </ul>
                                </div>
                            )))}
                    </>) : (<p>No data available.</p>)}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={() => setDetailsModal(false)}>Close</Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>Accepted Pieces Exceed's Expected Quantity</h2>
                    <p>
                        The number of accepted pieces is greater than the expected pieces.
                        Are you sure you want to continue?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setConfirmModal(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => handleAcceptanceSubmit()}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddImport